export default {
    admin: {
        title: 'amministratrice',
        superadmin: {
            title: 'Super Admin',
            edit: 'modificare'
        },
        invite: {
            manage: 'Invita ambasciatori della comunità',
            resend: 'RECEND',
            resend_success: 'L\'invito è stato risentito',
        },
        events: {
            edit: {
                singular: 'Modifica evento',
                plural: 'Modifica eventi',
            },
            overview: 'eventi',
        },
        organizations: {
            edit: {
                singular: 'Modifica organizzazione e marchio',
                plural: 'Modifica organizzazioni e marchi',
            },
            overview: 'organizzazioni e marchi',
        },
        pages: {
            edit: {
                singular: 'Modifica pagina',
                plural: 'Modifica pagine',
            },
            update: {
                success: 'pagina aggiornata',
                singular: "pagina di aggiornamento",
                title: "titolo",
                content: "contenuto",
                update_success: "pagina aggiornata correttamente"
            },
            overview: 'pagine',
            title: 'titolo',
            content: 'contenuto',
        },
        prices: {
            update: {
                success: 'Prezzi aggiornati',
                singular: "Aggiorna i prezzi",
                title: "titolo",
                content: "contenuto",
                update_success: "Prezzi aggiornati con successo"
            },
            success: 'Acquista successo',
        },
        users: {
            edit: {
                singular: 'Modifica l\'utente',
                plural: 'Modifica utenti',
            },
            active: 'Attivo',
            passive: 'Passivo',
            overview: 'utenti',
            impersonate: {
                button: 'Impersonare',
                loading: 'Caricamento...',
                error: 'Impossibile impersonare questo utente.',
            },
        },
        // LA-194: the links Admin hands out so an organiser can submit
        // an event without having an account.
        submission_links: {
            title: 'Link di invio',
            intro: 'Link con cui gli organizzatori inviano un evento senza account.',
            new: 'Nuovo link',
            new_hint: 'Crea un link da dare a un organizzatore via WhatsApp o e-mail.',
            create: 'Crea link',
            created: 'Link creato',
            search: 'Cerca',
            copy: 'Copia link',
            withdraw: 'Ritira',
            reactivate: 'Riattiva',
            no_brand: 'Nessun brand',
            empty: 'Ancora nessun link.',
            failed: 'Qualcosa è andato storto.',
            has_submissions: 'Da questo link sono già arrivati invii; ritiralo invece di eliminarlo.',
            delete_confirm: 'Eliminare il link {code}?',
            fields: {
                code: 'Codice',
                label: 'Descrizione',
                label_placeholder: 'es. Salsa Nights Rotterdam',
                brand: 'Brand',
                brand_placeholder: 'Cerca un brand',
                brand_hint: 'Facoltativo. Decide a quale brand appartiene l\'invio.',
                state: 'Stato',
                submissions: 'Invii',
                expires_at: 'Scade il',
                max_submissions: 'Max invii',
                contact_name: 'Contatto',
                contact_email: 'Indirizzo e-mail',
            },
            states: {
                all: 'Tutti',
                active: 'Attivo',
                expired: 'Scaduto',
                withdrawn: 'Ritirato',
                full: 'Pieno',
            },
        },
        scraped_concepts: {
            title: 'Scraped Concepts', overview: 'Concepts Overview', edit: { title: 'Edit Concept' },
            columns: { source: 'Source', name: 'Name', dates: 'Dates', location: 'Location', organization: 'Organization', status: 'Status', brand_match: 'Brand', actions: 'Actions' },
            filters: { name: 'Event name', source: 'Source', status: 'Status', city: 'City', date_from: 'Date from', date_to: 'Date to', brand_status: 'Stato del brand' },

            brand_status: {
                unchecked: 'Non ancora verificato',
                unmatched: 'Non ancora su LatinMap',
                unmanaged: 'Esiste, non gestito',
                review: 'Da verificare',
                managed: 'Gestito',
            },
            match_signal: {
                email: 'trovato tramite e-mail',
                domain: 'trovato tramite sito web',
                name: 'trovato tramite nome',
                name_city: 'trovato tramite nome + città',
                fuzzy: 'nome simile — verificare',
            },
            unlink_brand: 'Scollega brand',
            organization_unlinked: 'Brand scollegato',
            unlink_confirm: {
                title: 'Scollegare il brand?',
                submit: 'Sì, scollega',
                body: 'Rimuovere il collegamento tra "{event}" e il brand "{brand}"?',
                note: 'Il concept resta nell\'elenco e può essere collegato a un altro brand. Non viene eliminato nulla.',
            },
            link_confirm: {
                title: 'Collegare il brand?',
                submit: 'Sì, collega',
                body: 'Collegare "{event}" al brand "{brand}"? L\'evento dovrà comunque essere approvato separatamente.',
                signal: 'Trovato:',
                warning_managed: 'Questo brand è gestito attivamente da un Professional. Collegare un evento raccolto può entrare in conflitto con il suo lavoro.',
                warning_review: 'Questa corrispondenza non è certa. Verifica che sia davvero lo stesso brand prima di collegare.',
            },
            link_match: 'Collega questo brand',
            refresh_matches: 'Aggiorna corrispondenze',
            refresh_matches_help: 'Ricalcola a quali brand esistenti appartengono gli organizzatori raccolti',
            matches_refreshed: 'Corrispondenze aggiornate: {certain} certe, {possible} da verificare',
            bulk: {
                selected: '{count} selezionati',
                link_matched: 'Collega brand trovato',
                approve: 'Approva',
                reject: 'Rifiuta',
                clear: 'Cancella selezione',
                running: 'In corso...',
                select_all: 'Seleziona tutto in questa pagina',
                select_one: 'Seleziona {name}',
                nothing_to_link: 'Nessuna corrispondenza certa nella selezione',
                nothing_to_unlink: 'Nessun brand collegato nella selezione',
                unlink: 'Scollega',
                result: '{succeeded} elaborati, {failed} saltati',
                confirm: {
                    title: 'Conferma azione di gruppo',
                    submit: 'Sì, continua',
                    body_approve: 'Pubblicare {count} concept? Quelli senza brand confermato o certo vengono saltati.',
                    body_reject: 'Rifiutare {count} concept?',
                    body_unlink: 'Rimuovere il collegamento al brand da {count} concept?',
                    unlink_skipped: '{skipped} della selezione vengono saltati: non hanno un brand collegato.',
                    body_assign: 'Collegare {count} concept al brand trovato? Gli eventi dovranno comunque essere approvati separatamente.',
                    assign_skipped: '{skipped} della selezione vengono saltati: già collegati o senza corrispondenza certa.',
                    and_more: 'e altri {count}',
                    assign_managed: '{count} di questi brand sono gestiti attivamente da un Professional. Collegare può entrare in conflitto con il loro lavoro.',
                },
            },
            status_labels: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' },
            no_organization: 'No organization assigned', no_results: 'No concepts found', assign_first: 'Please assign an organization first',
            assign_organization: 'Assign Organization', search_organization: 'Search organization by name', current_organization: 'Currently assigned',
            organization_assigned: 'Organization assigned successfully', approve: 'Approve', reject: 'Reject',
            approved_success: 'Concept approved and event created', rejected_success: 'Concept rejected', approve_error: 'Failed to approve',
            save_success: 'Concept saved', scraped_at: 'Scraped at', view_source: 'View source', photos: 'Photos', admin_notes: 'Admin notes',
            reject_confirm: { title: 'Reject Concept', body: 'Are you sure you want to reject this concept?', submit: 'Reject' },
            search_btn: 'Search',
            back: 'Back',
            missing_fields: 'Please fill in the required fields',
            scraping: 'Scraping',
            scrape_result: 'Fetched {fetched}, created {created}, skipped {skipped}, errors {errors}',
        },
        report: {
            details: 'dettagli:',
            reported: 'riportato da:',
            suspended_at: 'sospeso a:',
            email: 'e-mail:',
            phonenumber: 'numero di telefono',
            message: 'messaggio:',
            singular: 'rapporto',
            plural: 'segnalazioni',
            reportables: {
                event: 'eventi',
                organization: 'organizzazioni',
            },
            status: {
                submitted: 'Inviato',
                under_review: 'In fase di revisione',
                resolved: 'Risolta',
                no_issue: 'Nessun problema',
            },
            reportables_by_type: {
                event: 'evento',
                organisation: 'organizzazioni e marchi',
                user: "utente",
                created_by: 'creato da',
                report_by: 'Rapporto di',
                ip_adress: 'Addetto IP',
                reason: 'motivo',
                description: 'descrizione',
                empty: 'vuota',
            },
            no_reports: 'Nessun rapporto trovato',
        },
        lead: {
            singular: 'Guida',
            plural: {
                event: 'Lead dell\'evento',
                organization: 'Lead del marchio'
            }
        },
        block_user: {
            plural: 'Blocca gli utenti',

            title: 'bloccata',
            description: 'Il tuo account è stato bloccato, non hai più accesso alla piattaforma.'
        },
        setting: {
            plural: 'impostazioni',
            reset: {
                warning: {
                    title: 'Ripristina tutte le impostazioni nell\'amministratore.',
                    body: 'Sei sicuro di voler ripristinare tutte le impostazioni?'
                }
            }
        },
        permissions: {
            plural: 'autorizzazioni',
            levels: {
                'level-1': 'Super Admin',
                'level-2': 'amministratrice',
                'level-3': 'ambasciatrice',
                'level-4': 'Membro premium',
                'level-5': 'Membro professionale',
                'level-6': 'membro',
            },
            no_users_with_role: 'Non ci sono utenti con questo livello di ruolo.',
            rights: {
                'create-organization-on-behalf-of-other-user': 'Crea organizzazione per conto di altri utenti',
                'latinmap-verify': 'concedere lo stato verificato latinmap',
                invite: {
                    'level-3': 'Invita ambasciatori della comunità',
                },
                reports: {
                    view: 'Visualizza i rapporti',
                    delete: {
                        any: 'Elimina qualsiasi rapporto',
                    },
                    update: 'Aggiorna lo stato del rapporto',
                    export: 'Rapporti sull\'esportazione',
                },
                events: {
                    create: 'Crea eventi',
                    view: 'Visualizza gli eventi',
                    update: {
                        any: 'Aggiorna qualsiasi evento',
                        own: 'Aggiorna i propri eventi',
                    },
                    delete: {
                        any: 'Elimina qualsiasi evento',
                        own: 'Elimina i propri eventi',
                    },
                    publish: 'Pubblica eventi',
                    unpublish: 'eventi induriti',
                    ownership: {
                        own: 'cambiare la proprietà dei propri eventi',
                        any: 'modificare la proprietà di qualsiasi evento',
                    },
                    ticketshop: {
                        enable: 'Abilita TicketShop',
                    },
                },
                organisations: {
                    create: 'Crea organizzazioni e marchi',
                    update: {
                        any: 'Aggiorna eventuali organizzazioni e marchi',
                        own: 'Aggiorna le proprie organizzazioni e marchi',
                    },
                    delete: {
                        any: 'Elimina eventuali organizzazioni e marchi',
                        own: 'Elimina le proprie organizzazioni e marchi',
                    },
                    ownership: {
                        own: 'Cambia la proprietà delle proprie organizzazioni e marchi',
                        any: 'Cambia la proprietà di qualsiasi organizzazione e marchi',
                    },
                },
                users: {
                    edit: 'Modifica utenti',
                },
                leads: {
                    view: 'Visualizza lead',
                    delete: 'Elimina lead',
                },
                transfer_requests: {
                    view: 'Visualizza le richieste di trasferimento',
                    approve: 'approvare le richieste di trasferimento',
                }
            }
        },
        dance_styles: {
            title: 'Stili di danza',
            singular: 'stile di danza',
            create: {
                singular: 'Crea stile di danza',
            },
            edit: {
                singular: 'Modifica lo stile di danza',
                plural: 'Modifica stili di danza',
            },
            delete: {
                title: 'Elimina lo stile di danza?',
                singular: 'eliminare',
                cancel: 'cancellare',
                confirmation: 'Questo stile di danza ha stili di danza secondaria.',
                affected: 'Questo stile di danza è usato nelle organizzazioni {event_count} e {organization_count}.',
                label: 'Elimina lo stile di danza',
                placeholder: 'Digita "{keyword}" qui e invia per rimuovere questo stile di danza.',
            },
            sub_dance_style: 'Style sub dance',
            is_favorite: 'è preferito',
        },
        music_styles: {
            title: 'Stili musicali',
            singular: 'stile musicale',
            create: {
                singular: 'Crea stile musicale',
            },
            edit: {
                singular: 'Modifica lo stile musicale',
                plural: 'Modifica stili musicali',
            },
            delete: {
                title: 'Elimina lo stile musicale?',
                singular: 'eliminare',
                cancel: 'cancellare',
                confirmation: 'Questo stile musicale ha stili di musica sub.',
                affected: 'Questo stile musicale viene utilizzato nelle organizzazioni {event_count} e {Organization_Count}.',
                label: 'Elimina lo stile musicale',
                placeholder: 'Type "{keyword}" here and submit to remove this music style.',
                substyles: 'Questo stile musicale ha stili sub-music.',
            },
            sub_dance_style: 'Style sub dance',
            sub_music_style: 'Stile di musica sub',
            is_favorite: 'è preferito',
        },
        featuredEvent: 'Evento in primo piano',
        event_types: {
            edit: {
                plural: 'Modifica i tipi di eventi',
            }
        },
        brand_types: {
            edit: {
                plural: 'Modifica i tipi di marchio',
            }
        },
        prof_financial_title: 'Centro finanziario',
        modoration:
        {
            title: 'moderazione',
        },
        official_brands: 'offical brands',
        export: {
            overview: {
                title: 'esportazione e trasferimenti',
                subtitle: 'Esporta tutte le organizzazioni, verrà generato un collegamento di trasferimento per ciascuna organizzazione.'
            },
            create: 'Crea esportazione',
            copied_link: 'Link copiato',
            take_ownership: 'prendere la proprietà',
            validate_phone: 'Per assumere la proprietà di questa organizzazione devi prima convalidare il tuo numero di telefono, questo può essere fatto qui sotto:',
            require_login: 'Per assumere la proprietà di questa organizzazione devi prima accedere o creare un account, questo può essere fatto qui di seguito:',
            to_login: 'per accedere',
            messages: {
                opened: 'Il tuo collegamento di trasferimento è stato attivato con successo, hai 30 giorni per completare il processo.',
                continue: 'Il collegamento di trasferimento è stato riaperto con successo, per favore termina il processo di trasferimento.',
                no_key: 'Non è stata fornita alcuna chiave, questo può accadere se hai aggiornato la pagina, è necessario aprire di nuovo il link originale.',
                not_exists: 'Attualmente non esiste un collegamento di trasferimento per questa organizzazione.',
                expired: 'This link has expired. Contact LatinMap to receive a new transfer link.',
                unauthorized: "Non sei autorizzato ad accettare questo trasferimento di organizzazione.",
                already_completed: 'Questo link è già stato completato e non può più essere utilizzato.',
                transferred: 'L\'organizzazione è stata trasferita con successo.'
            },
            warning: {
                title: 'Elimina il collegamento di trasferimento',
                body: 'Sei sicuro di voler eliminare questo link di trasferimento?'
            },
            status: {
                no_action: 'non trasferito',
                opened: 'aperto',
                completed: 'trasferito',
                expired: 'scaduta'
            }
        },
        duplications: 'duplicazioni',
        suspend_toggle: {
            warning: {
                title: 'Attiva sospensione',
                body: 'Sei sicuro di voler cambiare la sospensione di questo?'
            }
        },
        take_offline: {
            warning: {
                title: 'Prendi offline',
                body: 'Sei sicuro di voler prendere questo offline, non sarà più visibile per gli utenti.'
            }
        },
        bring_online: {
            warning: {
                title: 'Mettere online',
                body: 'Sei sicuro di voler mettere questo online? Sarà visibile per gli utenti.'
            }
        },
        'carousel-image': {
            plural: "Immagini del carosello",
            overview: {
                title: "Immagini del carosello",
                subtitle: "Gestisci le immagini del carosello nella homepage."
            },
            create: {
                singular: "Crea immagine del carosello",
                success: "Immagine del carosello creata con successo",
                error: "Errore nella creazione dell'immagine del carosello"
            },
            delete: {
                success: "Immagine del carosello eliminata con successo",
                error: "Errore nell'eliminazione dell'immagine del carosello"
            },
            image: "Immagine",
            visibility: 'Secondi visibili',
            title: "Titolo",
            order_by: "Ordina per",
            warning: {
                body: "Sei sicuro di voler eliminare questa immagine del carosello? Questa azione non può essere annullata.",
                title: "Elimina immagine del carosello"
            },
        },
        'beta-feature': {
            plural: 'Funzionalità beta',
            overview: {
                title: 'Funzionalità beta',
                subtitle: 'Gestisci le funzionalità beta disponibili per gli utenti.',
                success: 'Funzionalità beta salvata con successo',
                error: 'Errore durante il salvataggio della funzionalità beta',
            },
            key: 'Chi',
            name: 'Nome',
            description: 'Descrizione',
            visible_to_admins: 'Visibile agli amministratori',
            visible_to_users: 'Visibile agli utenti',
        }
    },
    nav_headers: {
        agenda: {
            label: 'Agenda Latin',
            options: {
                all_events: 'Tutti gli Eventi',
                latin_festivals_and_congresses: 'Festival e Congressi Latin',
                latin_parties_and_socials: 'Parti Latin e Socials'
            }
        },
        dance_schools: {
            label: 'Scuole di Danza Latin',
            options: {
                dance_schools: 'Scuole di Danza',
                try_outs_and_start_courses: 'Prova out e Inizia i Corsi',
                workshops_and_bootcamps: 'Workshop e Bootcamps',
                about_the_latin_dance_scene: 'Informazioni Sulla Scena Della Danza Latin'
            }
        },
        community: {
            label: 'Comunità Latin',
            options: {
                teachers: 'Insegnanti',
                show_performers_and_teams: 'Mostra Artisti e Squadre',
                djs: 'DJ',
                live_bands: 'Band/Musica dal Vivo',
                media_photo_video: 'Media, Foto, Video',
                mcs: 'MC\'s'
            }
        },
        dancewear_and_shoes: {
            label: 'Danza e Scarpe Latin',
            options: {
                dancewear_and_shoes: 'Danza e Scarpe'
            }
        },
        for_professionals: {
            label: 'Per Professionisti',
            options: {
                create_a_brand: 'Come Creare un Marchio',
                create_an_event: 'Come Creare un Evento',
                promote_your_event: 'Come Promuovere il Tuo Evento',
                professional_account_verification: 'Verifica del Conto Professionale'
            }
        },
        join: {
            label: 'Unisciti a LatinMap',
            options: {
                create_a_brand_or_organization: 'Crea un Marchio o un\'Organizzazione',
                become_an_ambassador: 'Diventare un Ambasciatore'
            }
        },
        manage_and_promote: {
            label: 'Gestire e Promuovere',
            options: {
                my_events: 'I Miei Eventi',
                promote_your_event: 'Promuovi il tuo Evento'
            }
        }
    },
    impersonation: {
        banner: 'Stai visualizzando come {name}',
        stop: 'Smetti di impersonare',
    },
    menu_headers: {
        general_title: 'generale',
        orders_title: 'i miei ordini',
        settings_title: 'impostazioni',
        professional_title: 'professionale',
        prof_financial_title: 'il mio centro finanziario',
        special_access_title: 'Accesso speciale',
        community_dashboard_title: 'Il mio ambasciatore della dashboard della comunità',
        session_title: 'sessione',
    },
    account: {
        owned_by_organization: "Di proprietà dell'organizzazione {organization_name}",
        organization_settings_title: 'Impostazioni Organizzazione',
        selected_organization: 'Organizzazione selezionata',
        my_events: 'I miei eventi',
        role: 'it',
        dashboard: "pannello di controllo",
        default_filters: "le mie ricerche",
        login: "login",
        logout: "Logout",
        sign_in: "registrazione",
        sign_up: "iscrizione",
        email_address: "indirizzo e-mail",
        password: "password",
        password_repeat: "Ripeti la password",
        password_reset: "reimpostazione della password",
        password_forgot: "password dimenticata",
        reset_password: "reimpostare la password",
        current_password: "password attuale",
        change_password: "cambiare la password",
        new_password: "Nuova password",
        password_reset_success: "reimpostazione della password di successo",
        forgot_password: "Ha dimenticato la password",
        not_a_member: "non un membro",
        i_already_have_an_account: "Ho già un account",
        i_accept_the: "Accetto il",
        terms_and_conditions: "Termini e Condizioni",
        first_name: "nome di battesimo",
        last_name: "cognome",
        postal_code: "Codice Postale",
        street_number: "numero di strada",
        city: "città",
        country: "Paese",
        preferred_language: "Lingua preferita",
        date_of_birth: "data di nascita",
        create: "creare un account",
        my_account: "il mio conto",
        my_professional_dashboard: "La mia dashboard professionale",
        ambassador_dashboard: "Dashboard di Ambassador",
        my_organisations: "le mie organizzazioni e marchi",
        my_organisations_description: "Gestisci le tue organizzazioni e marchi",
        singular: "account",
        phone: "Numero di telefono",
        phone_verification_token: "Token di verifica del telefono",
        name: "nome",
        user_name: "nome utente",
        resend_verification: "Resendendo la verifica",
        update_error: 'L\'aggiornamento del tuo account non è riuscito.',
        myLatinmap: "La mia LatinMap",
        dancerprofile: "Il mio profilo da ballerino",
        orders: 'i miei ordini',
        phone_verification: 'Verifica del telefono',
        submitted_leads: 'I miei contatti presentati',
        settings: 'impostazioni',
        switch: 'Passa al marchio/organizzazione',
        beta_features: 'Funzionalità beta',
        gender: {
            singular: "genere",
            male: "maschia",
            female: "femmina",
            other: "altra",
        },
        profile: {
            title: 'profilo',
            description: 'Gestisci le informazioni del tuo profilo, modifica la password e altro ancora.',
        },
        remove: {
            label: 'Rimuovere l\'account',
            placeholder: 'Type "delete" here and submit to remove your account.',
            admin_placeholder: 'Type "delete" here and submit to remove this account.',
            safeword: 'eliminare',
            description: 'Ciò rimuoverà il tuo account e tutti i dati associati.',
        },
        favorites: {
            title: 'preferite',
            description: 'I tuoi eventi preferiti, scuole di danza ecc.',
            no_favorites: 'Non hai ancora preferiti in questa categoria',
            plurals: {
                event: 'eventi',
                dancer: 'ballerine',
                dj: 'DJ',
                media: 'media',
                brand: 'scarpe da ballo, abbigliamento, negozio',
                school: 'Scuole di danza',
                venue: 'it',
                club: "club",
                teacher: "insegnante",
                show_performers_and_teams: "Mostra artisti e squadre",
                performer: "artista",
                mc: "MC",
                latin_music: "musica latina",
                event_organizer: "Organizzatore di eventi",
                organization: 'organizzazioni e marchi',
            },
        },
        likes: {
            title: 'Mi piace',
            description: 'I tuoi eventi apprezzati, le scuole di danza ecc.',
            no_likes: 'Non hai ancora Mi piace in questa categoria',
            plurals: {
                event: 'eventi',
                dancer: 'ballerine',
                dj: 'DJ',
                media: 'Media (foto, video, editing video)',
                brand: 'scarpe da ballo, abbigliamento, negozio',
                school: 'Scuole di danza',
                venue: 'it',
                club: "club",
                teacher: "insegnante",
                show_performers_and_teams: "Mostra artisti e squadre",
                performer: "artista",
                mc: "MC",
                latin_music: "musica latina",
                event_organizer: "Organizzatore di eventi",
                organization: 'organizzazioni e marchi',
            },
        },
        verification: {
            phone: {
                description: "La verifica del telefono è necessaria per garantire la sicurezza e l\'autenticità degli utenti che accedono alla dashboard \\",
                not_verified: 'Il tuo numero di telefono non è verificato.',
                send_verification_text: 'Invia testo di verifica',
                sent: 'testo di verifica inviata',
                verified: 'Il tuo numero di telefono è verificato.',
                verify: 'Verificare il numero di telefono',
            },
        },

    },
    dashboard: {
        title: "pannello di controllo",
        welcome: "benvenuta",
    },
    organizations: {
        organization_saved: 'Organizzazione salvata',
        containing_emoji_error: 'Le emoji non sono ammesse nel nome. Utilizza caratteri alfanumerici o caratteri speciali consentiti.',
        invalid_character_error: 'C\'è un carattere non valido nel nome. Utilizzare caratteri alfanumerici o caratteri speciali consentiti.\nCaratteri non validi:',
        overview: {
            filters: {
                option_labels: {
                    favorites: {
                        all: 'tutta',
                    },
                    organization_type: {
                        all: 'tutta',
                        dance_schools: 'Scuole di danza',
                        organizers: 'organizzatrici',
                        artists: 'it',
                        disk_jockeys: 'DJ',
                    }
                }
            },
            no_results: {
                title: 'Nessuna organizzazione trovata',
                subtitle: 'Nessuna organizzazione trovata per i filtri selezionati.'
            },
        },
        transfers: {
            overview: {
                title: 'trasferimenti',
                subtitle: 'Gestisci la proprietà delle tue organizzazioni',
                incoming_transfers: 'trasferimenti in arrivo',
                outgoing_transfers: 'trasferimenti in uscita',
                request: 'richiesta',
                offer: 'offerta',
                event: 'evento',
                organization: 'organizzazione',
            },
            status: {
                approved: 'trasferimento accettato',
                pending: 'in attesa di',
                rejected: 'Il trasferimento è diminuito'
            },
            create: {
                title: 'Trasferisci la proprietà',
                organization: 'organizzazione',
                description: 'Trasferisci la proprietà della propria organizzazione a un altro utente.',
                reason: 'motivo',
                transfer_to: 'Trasferimento a (e -mail)',
                transfer: 'trasferire',
                warning: 'Non appena il trasferimento sarà accettato, la proprietà dell\'organizzazione verrà trasferita al nuovo proprietario.',
            }
        },
        remove: {
            label: 'Rimuovere Organizzazione',
            description: 'Eliminare permanentemente questa organizzazione e tutti i dati associati.',
            success: 'Organizzazione eliminata con successo',
            error: 'Impossibile eliminare l\'organizzazione'
        },
        transactions: {
            overview: {
                title: 'transazioni',
                subtitle: 'Gestisci le transazioni delle tue organizzazioni e marchi',
            }
        },
        create: 'Crea organizzazione',
        is_public_options: {
            private: 'privata',
            public: 'pubblica',
            private_warning: 'La tua organizzazione non è visibile online con questo stato.'
        },
        offline_preview: 'Questa organizzazione è offline ed è visibile solo come anteprima.',
    },
    organization: {
        accepts_posts_on_behalf: 'Consenti a LatinMap di aggiungere i nostri eventi',
        accepts_posts_on_behalf_help: 'Quando il nostro brand è fermo, LatinMap può aggiungere eventi annunciati pubblicamente a nostro nome. Sono chiaramente contrassegnati e puoi modificarli o rimuoverli quando vuoi.',
        'on-behalf-of': 'per conto di',
        'on-behalf': {
            none: 'Seleziona la tua opzione',
            me: 'Io, rappresento questo marchio',
            other: 'Come rappresentante del marchio',
            noone: 'Come ambasciatore di LatinMap',
        },
        featured: {
            title: 'Scuole di danza in primo piano',
            subtitle: 'Alcune delle accademie da ballo in primo piano e più votate con corsi di danza ora disponibili.',
        },
        my_favorites: {
            title: 'i miei preferiti',
        },
        edit: {
            public_information: 'informazioni',
            customers: 'clienti',
            events: 'eventi',
            tickets: 'Biglietti',
            authorized_person: 'persone autorizzate',
        },
        organization_detail: {
            involved: 'coinvolta',
            verification_status: {
                verified: 'verificato',
                not_verified: 'non ancora verificato',
            }
        },
        account: {
            title: "account",
            description: "Gestisci le informazioni sul tuo account per la dashboard professionale.",
            description_not_verified: "Verificare il numero di telefono per utilizzare la dashboard professionale.",
        },
        transfer: {
            title: 'Trasferisci la proprietà',
            description: 'Vuoi richiedere la proprietà di questa organizzazione?',
            what: 'Cosa viene offerto?',
            submit: 'Richiesta di invio',
            name: 'nome',
            location: 'posizione',
            email: 'e-mail',
            reason: 'motivo',
            organization: 'organizzazione e marchio',
            errors: {
                nameRequired: 'è richiesto il nome.',
                emailRequired: 'È richiesta l\'e -mail.',
                reasonRequired: 'è richiesta la ragione.'
            },
            succesfully_sent: 'La richiesta di trasferimento è stata inviata con successo.',
            error_occurred: 'Qualcosa è andato storto.',
            noOrganisation: 'Non hai ancora organizzazioni.'
        },
        title: "organizzazione",
        is_public: 'è pubblico',
        publicly_visible: 'pubblicamente visibile',
        change_organization: "Cambia organizzazione",
        create: "Crea organizzazione",
        name: "nome",
        name_without_dj: "Nome (senza 'dj')",
        dj_name_tooltip: "Inserisci solo il nome. 'DJ' verrà aggiunto automaticamente",
        email: "e-mail",
        phone: "Numero di telefono",
        phone_verification_token: "Token di verifica del telefono",
        country: "Paese",
        city: "città",
        street: "strada",
        street_number: "numero di strada",
        postal_code: "Codice Postale",
        type: "tipa",
        question: "La tua organizzazione?",
        types: {
            event: 'Evento',
            dancer: "ballerina",
            latin_music: "musica latina",
            performer: "artista",
            teacher: "insegnante",
            show_performers_and_teams: "Mostra artisti e squadre",
            dj: "DJ",
            mc: "MC",
            media: "Media (foto, video, editing video)",
            brand: "scarpe da ballo, abbigliamento, negozio",
            event_organizer: "Organizzatore di eventi",
            school: "Scuola di danza",
            live_music: "Band/musica dal vivo",
            venue: "luogo",
        },
        short_description: "Breve descrizione",
        long_description: "Descrizione lunga",
        photos: "foto",
        dance_styles: "Stili di danza",
        music_styles: "Stili musicali",
        my_brands: "i miei marchi",
        my_brands_description: "Gestisci i tuoi marchi",
        overview: {
            title: 'Scuole di danza',
            subtitle: 'Trova le migliori scuole di danza nella tua zona.',
            filters: {
                organization_name: 'Nome dell\'organizzazione',
                dance_styles: 'Stili di danza',
                postal_code: 'Codice Postale',
                nearby_range: 'Range di suggerimenti postali nelle vicinanze',
                nearby: 'Suggerimenti nelle vicinanze',
                location: 'Dove',
                favorites: 'preferite',
                country_codes: 'Codici di paese',
                music_styles: 'Stili musicali',
                ambassadors: 'ambasciatori',
                slidertooltip: '<p><strong> Il cursore della gamma regola le cifre del codice postale immesso per espandere l\'area di ricerca. </strong><p> Ogni passaggio aumenta il codice postale di 100. </p><p> Ad esempio, a',
            },
            organizers: {
                title: 'organizzatrici',
                subtitle: 'Trova i migliori organizzatori della tua zona.',
            },
            artists: {
                title: 'it',
                subtitle: 'Trova i migliori artisti della tua zona.',
            },
            dance_schools: {
                title: 'Scuole di danza',
                subtitle: 'Trova le migliori scuole di danza nella tua zona.',
            },
            disk_jockeys: {
                title: 'DJ',
                subtitle: 'Trova i migliori DJ nella tua zona. Goditi i migliori eventi e festival.',
            },
            show_performers_and_teams: {
                title: 'Mostra artisti e squadre',
                subtitle: 'Trova i migliori artisti nella tua zona.',
            },
            teacher: {
                title: 'insegnanti',
                subtitle: 'Trova i migliori insegnanti nella tua zona.',
            },
            mcs: {
                title: "MC\'s",
                subtitle: 'Trova i migliori MC nella tua zona.',
            },
            live_music: {
                title: "Band/musica dal vivo",
                subtitle: 'Trova le migliori band e musica dal vivo nella tua zona.',
            },
            live_performer: {
                title: "Performer dal vivo",
                subtitle: 'Trova i migliori artisti dal vivo nella tua zona.',
            },
            performer: {
                title: "artista",
                subtitle:
                    "Trova i migliori artisti dal vivo nella tua zona. Goditi i migliori eventi e festival."
            },
            media: {
                title: "Media (foto, video, editing video)",
                subtitle: 'Trova i migliori fotografi e videografi nella tua zona.',
            },
            brand: {
                title: "scarpe da ballo, abbigliamento, negozio",
                subtitle: 'Trova le migliori scarpe da ballo e abbigliamento nella tua zona.',
            },
        },
        artists: {
            title: 'it',
        },
        teacher: {
            title: 'insegnanti',
        },
        performer: {
            title: 'artiste'
        },
        show_performers_and_teams: {
            title: 'Mostra artisti e squadre',
        },
        dance_schools: {
            title: 'Scuole di danza',
        },
        disk_jockeys: {
            title: 'DJ',
        },
        organizers: {
            title: 'organizzatrici',
        },
        manage_authorized_people: {
            title: 'Gestisci persone autorizzate',
            description:  'Gestisci le persone autorizzate delle organizzazioni di cui sei proprietario. Le persone autorizzate possono gestire la tua organizzazione e i tuoi eventi.'
        },
        authorized_people: {
            title: 'Persone autorizzate',
            description: 'Gestisci le persone autorizzate delle tue organizzazioni. Le persone autorizzate possono gestire la tua organizzazione e i tuoi eventi.',
            create: 'Crea persona autorizzata',
            edit: 'Modifica persona autorizzata',
            overview: 'Persone autorizzate',
            not_found: 'Nessuna persona autorizzata trovata',
        },
        mcs: {
            title: "MC\'s",
        },
        live_music: {
            title: "Band/musica dal vivo",
        },
        live_performer: {
            title: "artisti dal vivo",
        },
        media: {
            title: "Media (foto, video, editing video)",
        },
        brand: {
            title: "scarpe da ballo, abbigliamento, negozio",
        },
        email_authorized: 'Immettere un indirizzo email esistente.',
    },
    ambassador: {
        profile: "profilo",
        my_brands: "i miei marchi",
        verification: {
            phone: {
                description: "La verifica del telefono è necessaria per garantire la sicurezza e l\'autenticità degli utenti che accedono alla dashboard \\"
            }
        }
    },
    brands: {
        create: "Crea marchio",
        brand_saved: "Brand salvato",
        change_brand: "Cambia il marchio",
        edit: {
            authorized_person: "persone autorizzate"
        },
        posted_by_ambassador_text: 'Questo marchio è stato creato da un ambasciatore Latinmap, un membro della comunità di fiducia che ha contribuito ai contenuti della piattaforma.',
    },
    contact: {
        title: "contatto",
        name: "nome",
        email: "e-mail",
        message: "messaggio",
        subject: "soggetta",
        send: "Inviare",
        success: "messaggio inviato",
        error: "non è stato possibile inviato il messaggio",
    },
    ticketstore: {
        select_amount: 'Seleziona l\'importo del biglietto',
        your_information: 'le tue informazioni',
        total: 'totale',
        next: 'prossima',
        back: 'Indietro',
        checkout: 'guardare',
        tickets_for: 'Biglietti per',
        ticket_types: 'Tipi di biglietti',
        ticket: {
            starts_at: 'inizia da',
            location: 'posizione',
            name: 'nome',
            description: 'descrizione',
            tickets_sold: 'Biglietti venduti',
            actions: 'azioni',
            available: 'disponibile',
            total_available: 'totale disponibile',
            price: 'prezzo',
            create: 'Crea tipo di biglietto',
            edit: 'Modifica tipo di biglietto',
            success: 'Il tipo di biglietto è stato inviato con successo.',
            remove_label: 'Rimuovere il tipo di biglietto',
            remove_description: 'Ciò rimuoverà il tipo di biglietto e tutti i dati associati.',
        },
    },
    events: {
        select_category: "Seleziona una categoria",
        select_country: "Seleziona un paese",
        select_timezone: "Seleziona un fuso orario",
        select_status: "Seleziona uno stato",
        select_currency: "Seleziona una valuta",
        select_brand_error: "Nessuna marca selezionata",
        title: 'eventi',
        bring_online: 'portare online',
        take_offline: 'togliere la linea',
        by: 'Eventi di {organization_name}',
        create_new: 'Crea nuovo evento',
        event_saved: 'Evento salvato',
        event_published: 'Il tuo evento è ora in diretta e visibile nella pagina degli eventi.',
        error_saving: 'Errore di salvataggio dell\'evento',
        containing_emoji_error: 'Le emoji non sono ammesse nel nome. Utilizza caratteri alfanumerici o caratteri speciali consentiti.',
        invalid_character_error: 'C\'è un carattere non valido nel nome. Utilizzare caratteri alfanumerici o caratteri speciali consentiti.\nCaratteri non validi: ',
        duration_too_long: 'La durata di questo evento è troppo lunga, il numero massimo di giorni che un evento è autorizzato a prendere è: ',
        error_updating_ticket_type: 'Si è verificato un errore durante il salvataggio del tipo di biglietto.',
        ticket_type_updated: 'Il tipo di biglietto è stato aggiornato correttamente.',
        posted_by_ambassador: 'Postato da Latinmap Ambassador',
        posted_by_ambassador_text: 'Questo evento è stato creato da un ambasciatore Latinmap, un membro della comunità di fiducia che ha contribuito al contenuto della piattaforma.',
        posted_on_behalf_text: 'LatinMap ha aggiunto questo evento sulla base di informazioni pubblicamente disponibili. L\'organizzatore non ha ancora aggiornato personalmente queste informazioni.',
        posted_on_behalf_label: 'aggiunto da LatinMap',
        // LA-202: the public pill on the event page. Separate from the
        // line above, which is appended to a title in the organiser's own
        // list and reads as a note rather than a credit.
        posted_by_latinmap: 'Pubblicato da LatinMap',
        not_posted_by_ambassador: 'Verificato dall\'organizzatore',
        participants: {
            create: {
                title: 'Crea partecipante per "{event_name}"',
                description: 'Crea un nuovo partecipante all\'evento "{event_name}"',
                invite: 'Invita il partecipante',
                role: 'ruolo',
            },
            role: {
                performer: 'artista',
                organizer: 'organizzatrice',
            },
            overview: {
                participants: 'partecipanti',
            }
        },
        statuses: {
            active: 'attiva',
            canceled: 'annullata',
            changed: 'cambiato',
            pending: 'in attesa di'
        },
        currencies: {
            none: 'Nessuna valuta',
            euro: 'Eura',
            dollar_american: 'Dollaro Americano',
            pound_uk: 'Sterlina Inglese',
            lira_turkish: 'Lira Turca',
            rupee_indian: 'Rupia Indiana'
        },
        event_detail: {
            cta_block: {
                title: 'Biglietti',
                subtitle: 'Ci sono biglietti disponibili per questo evento!',
                button: 'Ottieni ora i tuoi biglietti'
            },
            organizer: {
                plural: 'organizzatrici',
                singular: 'organizzatrice',
                invariable: 'organizzatore (i)',
            }
        },
        overview: {
            title: 'eventi',
            nearby_events: 'Eventi nelle vicinanze',
            subtitle: 'Immergiti nei ritmi ritmici, nelle mosse esaltanti e nella fusione culturale di salsa, bachata e altro ancora.',
            festival: {
                title: 'festival di danza e congressi',
            },
            try_out: {
                title: 'Provini, giornata porte aperte, inizio corsi',
            },
            party_social: {
                title: 'Feste e Social',
            },
            no_results: {
                title: 'Nessun evento trovato',
                subtitle: 'Nessun evento trovato per i filtri selezionati.'
            },
            filters: {
                event_name: 'Nome dell\'evento o dell\'organizzazione',
                event_id: "ID dell'evento",
                event_category: 'Tipo di evento',
                dance_styles: 'Stili di danza',
                dance_style: 'stile di danza',
                music_styles: 'Stili musicali',
                music_style: 'stile musicale',
                ambassadors: 'ambasciatori',
                status: 'stato',
                user_name: 'utente',
                user_type: 'Tipo di utente',
                organization: 'organizzazione',
                organization_type: 'Tipo di organizzazione',
                location: 'Dove',
                date: 'Quando',
                date_from: 'da',
                date_to: 'A',
                apply_filters: 'Applicare i filtri',
                clear_filters: 'filtri chiari',
                country_codes: 'Codici di paese',
                city: 'città',
                favorites: 'preferite',
                postal_code: 'Codice Postale',
                nearby_range: 'Range di suggerimenti postali nelle vicinanze',
                apply: 'fare domanda a',
                sliderinfo: 'incrementi di 100',
                slidertooltip: '<p><strong> Il cursore della gamma regola le cifre del codice postale immesso per espandere l\'area di ricerca. </strong><p> Ogni passaggio aumenta il codice postale di 100. </p><p> Ad esempio, a',
                option_labels: {
                    date_filter: {
                        upcoming: 'imminente',
                        this_week: 'Questa settimana',
                        next_week: 'la prossima settimana',
                        in_two_weeks: 'Tra due settimane +',
                        this_month: 'questo mese',
                        specific_dates: 'date specifiche',
                        all: 'tutta'
                    },
                    favorites: {
                        all: 'tutta',
                        favorites: 'preferite',
                        likes: 'mostra solo i miei eventi apprezzati',
                        favorites_likes: 'mostra gli eventi o gli eventi di marchi preferiti',
                    },
                    organization_type: {
                        all: 'tutta',
                        dance_schools: 'Scuole di danza',
                        organizers: 'organizzatrici',
                        music_styles: 'Stili musicali',
                        music_style: 'stile musicale',
                        artists: 'it',
                        disk_jockeys: 'DJ',
                    },
                    user_type: {
                        professional: 'professionale',
                        ambassador: 'ambasciatrice',
                        admin: 'amministratrice',
                        superadmin: 'it'
                    }
                }
            },
            workshop_bootcamp: {
                title: 'Workshop e bootcamps',
            },
        },
        type: {
            festivals_and_congresses: 'festival e congressi',
            try_out: 'Provini, giornata porte aperte, inizio corsi',
            live_music: 'Band/musica dal vivo',
            workshop_bootcamp: 'Workshop e bootcamps',
        },
        categories: {
            festival: 'Festival/Congresso',
            workshop_bootcamp: 'Workshop/bootcamp',
            workshop_bootcamp_party: 'Festa con workshop/bootcamp',
            party_social: 'Party/Social',
            competition: 'concorrenza',
            performance_concert: 'Performance/Concert',
            outdoor_event: 'evento all\'aperto',
            dance_trip: 'viaggio di danza',
            party_live_music: 'Musica di festa/dal vivo',
            online_event: 'Evento online',
            try_out: 'Provini, giornata porte aperte, inizio corsi',
            show: 'spettacolo',
            marathon: 'maratona',
            weekender: 'Weekender',
            retreat: 'Ritiro',
            other: 'altra',
        },
        create: 'Crea evento',
        edit: 'Modifica evento',
        remove: {
            label: 'Rimuovere l\'evento',
            description: 'Ciò rimuoverà l\'evento e tutti i dati associati.',
        },
        brand: 'marca/organizzazione',
        name: 'nome',
        country: 'Paese',
        city: 'città',
        street: 'strada',
        street_number: 'numero di strada',
        short_description: 'Breve descrizione',
        long_description: 'Descrizione lunga',
        dance_styles: 'Stili di danza',
        music_styles: 'Stili musicali',
        photos: 'foto',
        photos_preview_mode: 'Le foto sono visibili dopo aver salvato in modalità Anteprima',
        preview: 'spettacolo',
        category: 'Tipo di evento',
        language: 'lingua',
        location_type: {
            singular: 'Tipo di posizione',
            online: 'virtuale',
            offline: 'di persona',
        },
        timezone: 'fuso orario',
        date: 'data',
        week: 'settimana',
        start: 'inizio',
        end: 'FINE',
        location: 'posizione',
        information: 'informazioni',
        start_date: 'Data di inizio',
        start_time: 'ora di inizio',
        end_date: 'Data di fine',
        end_time: 'ora di fine',
        ends_at: 'termina a',
        registration_opens_at: 'La registrazione si apre a',
        registration_closes_at: 'La registrazione si chiude a',
        is_public: 'Pronto per andare a vivere?',
        location_name: 'Nome del luogo',
        photos_required: 'È richiesta almeno una foto.',
        tickets_sold: 'Biglietti venduti',
        actions: 'azioni',
        participate: 'partecipare',
        verified: 'Verificato ufficiale del marchio',
        undercondition: 'non ancora confermato',
        warning: 'Cambiamento importante - Ultimo aggiornamento:',
        ticket:'Tickets available',
        cancelled: 'cancellato - ultimo aggiornamento:',
        upcoming: 'eventi imminenti',
        past: 'eventi passati',
        status: 'stato',
        status_reason: 'Motivo dello stato',
        entrance: 'Prezzi dei biglietti',
        entrance_tooltip: 'Qui puoi specificare il prezzo del biglietto. Inserisci un numero se il prezzo non cambia, ad esempio: \'5\'. Per un intervallo di prezzo puoi specificare un intervallo, ad esempio \'5-10\'. Usa \'free\' se non c\'è un prezzo di ingresso.',
        currency: 'valuta',
        currency_tooltip: 'È anche possibile specificare la valuta. Le valute più utilizzate sono: euro (€), dollaro americano ($), sterlina inglese (£), lira turca (₺) e rupia indiana (₹). Se non è selezionata alcuna valuta, puoi aggiungere qualsiasi testo, come \'5-12 euro\'.',
        repeat: 'ripeti',
        djs: 'DJ',
        dj: 'DJ',
        artists: 'artiste',
        artist: 'artista',
        question: "Il tuo evento?",
        status_options: {
            active: 'attiva',
            canceled: 'annullata',
            pending: 'non ancora confermato',
            changed: 'cambiamento importante',
        },
        is_public_options: {
            draft: 'bozza',
            private: 'privata',
            public: 'pubblica',
            draft_message: 'Salva il tuo evento come una bozza.',
            private_message: 'Il tuo evento sarà visibile solo agli utenti con accesso.',
            public_message: 'Pubblica il tuo evento per renderlo visibile nella pagina degli eventi.',
            private_warning: 'Il tuo evento non è visibile online con questo stato.'
        },
        legend: {
            title: 'leggenda',
            verified: 'Verificato ufficiale del marchio',
            not_verified: 'Non verificato dall\'organizzazione: l\'organizzatore non ha ancora confermato l\'attività.',
            cancelled: 'annullata',
            warning: 'cambiamento importante',
            posted_by: 'Postato da Latinmap Ambassador',
            condition: 'non ancora confermato',
            ticket:'Tickets available',
            duplicate_event_error: 'Un evento con questo nome, la data di inizio e la data di fine esiste già',
            ticket_order: 'Biglietti disponibili, acquistali qui!'
        },
        ticket_types: 'Tipi di biglietti',
        potential_duplicates: 'possibili duplicati',
        proceed_anyway: 'Salva nonostante duplicato',
        duplicate_event_error: 'Un evento con questo nome, la data di inizio e la data di fine esiste già',
        event_deleted: 'evento eliminato',
        error_deleting_event: 'ERRORE ELETTENZA EVENTO',
        featured: {
            title: 'Eventi in primo piano nella comunità',
            subtitle: 'Scopri e prendi i tuoi biglietti per festival di danza, concerti e viaggi al miglior prezzo!',
            badge: 'In evidenza',
            view: 'Vedi evento',
            title_page: 'Cambia il prezzo globale',
            featured_event: "Acquista evento in primo piano",
            duration_type: "Tipo di durata",
            day: "giorno",
            month: "mese",
            year: "anno",
            duration: "durata",
            price: "prezzo",
            calculate_price: "Calcola il prezzo",
            proceed_to_payment: "procedere al pagamento",
            current_price: "Prezzo attuale",
            no_price_found: "No price found for the selected duration",
            update_price: "Prezzo di aggiornamento",
            setFeaturedEvents: "Evento in primo piano",
            fetch_current_price: "Prendere il prezzo attuale",
            update_global_event_price: "Aggiorna il prezzo dell\'evento globale",
            price_per_day: 'Prezzo al giorno',
            buy: 'Acquista evento in primo piano',
            duration_label: 'Per quanto tempo vorresti presentare l\'evento?',
            enter_duration: 'Selezionare la durata',
            total_price: 'totale',
            yes: "SÌ",
            no: "NO",
            invalid_invoice: 'Qualcosa è andato storto, riprova',
            download_failed: 'Qualcosa è andato storto, riprova',
            setFeaturedEvent: 'Evento in primo piano per:',
            setFeatured: 'Evento in primo piano',
            featured_success: 'L\'evento è stato presentato con successo.',
            already_featured: 'Questo evento è già presente',
            featured_error: 'Qualcosa è andato storto',
            durationError: 'Il valore non può essere inferiore a 1'
        },
    },
    blocked_user:{
        create: 'Crea utente bloccato',
        edit: 'Aggiorna l\'utente bloccato',

        blocked_email: 'Email bloccata',
        blocked_phone_number: 'Numero di telefono bloccato',
        reason: 'motivo',

        delete: {
            warning: {
                title: 'Elimina il blocco dell\'utente',
                body: 'Are you sure you want to delete this block. When this block is deleted users that were previously blocked by this blocking will have all their rights back.'
            }
        }
    },
    carousel: {
        title: 'Scopri la danza latina: eventi, scuole, provini e altro ancora vicino a te!',
        subtitle: 'Scopri dove ballare, imparare e entrare in contatto con la comunità latina.',
        popular: 'Popolari',
        search: {
            placeholder: 'Inserisci una parola chiave o una città per scoprire le opzioni di danza latina...',
            button: 'SCOPRIRE',
        }
    },
    home: {
        // LA-179: the official Instagram strip that closes the homepage.
        instagram: {
            title: 'Dal vivo dalla pista',
            subtitle: 'Le ultime dal nostro Instagram: la scena com\'è davvero, settimana dopo settimana.',
            follow: 'Segui {handle}',
            post_alt: 'Un post di {handle} su Instagram',
        },
        cta_block_1: {
            title: 'Organizzi eventi di ballo?',
            subtitle:
                'Se organizzi feste, festival, uscite, congressi, weekend, workshop, corsi intensivi e concerti di ballo, abbiamo qualcosa per te. Promuovi il tuo evento, gestisci i promoter e vendi i biglietti!',
            button: 'Iscriviti ora'
        },
        cta_block_2: {
            title: 'Scopri Eventi Vicino a Te',
            subtitle:
                'Scopri eventi e attività nella tua zona. Esplora e goditi le esperienze!',
            placeholder: 'La tua posizione',
            input_button: 'Vicino a me',
            button: 'Trova eventi'
        },
        cta_block_3: {
            button: 'Crea Evento',
        },
        choose_and_live_experiences: 'Scegli e vivi esperienze',
        experiences: {
            festivals_congresses: "Festival & Congressi",
            parties_socials: "Feste, Social",
            try_outs_start_courses: "Prove, Corsi per principianti",
            dance_schools: "Scuole di ballo",
            workshops_bootcamps: "Workshop, Bootcamp",
            dancewear_shoes: "Abbigliamento & Scarpe da ballo",
            teachers: "Insegnanti",
            show_performers_teams: "Artisti & Team di spettacolo",
            djs: 'DJ\'s',
            live_music: "Band dal vivo",
            media_photo_video: "Media (Foto/Video)",
            mcs: "MC's"
        },
        cta_journey: {
            title: 'Inizia il tuo viaggio su LatinMap',
            subtitle: 'Scegli come vuoi vivere LatinMap',
            agenda: {
                title: 'Agenda Mondiale',
                sub_header: 'Accesso libero',
                subtitle: 'Esplora la scena globale della danza latina',
                description: 'Sfoglia feste, workshop, festival, lezioni di prova e corsi per principianti - tutto in un\'unica agenda',
                button: 'Vedi Latin Agenda',
                footer: 'Nessun account richiesto'
            },
            member: {
                title: 'Diventa Membro',
                sub_header: 'Account gratuito',
                subtitle: 'Costruisci la tua esperienza LatinMap',
                description: 'Crea la tua LatinMap personale e resta connesso alla scena della danza latina — localmente e internazionalmente.',
                features: {
                    agenda: 'Agenda completa e aggiornata di danza latina',
                    follow: 'Segui i tuoi eventi, artisti e marchi preferiti',
                    save: 'Salva i tuoi preferiti con un clic',
                    store: 'Memorizza le tue ricerche e scoperte',
                    custom_agenda: 'Crea la tua agenda personalizzata',
                    explore: 'Esplora nuove città, stili e scene'
                },
                button: 'Crea account gratuito',
                footer: 'Gratis da unirsi – non perdere mai più un evento'
            },
            professional: {
                title: 'Diventa Professionista',
                sub_header: 'Profilo professionale gratuito',
                subtitle: 'Per festival, scuole di ballo, insegnanti, DJ, musicisti e organizzatori',
                description: 'Aumenta la tua visibilità, gestisci i tuoi eventi e raggiungi la comunità latina internazionale.',
                features: {
                    brand_page: 'La tua pagina del marchio professionale',
                    publish: 'Pubblica e gestisci eventi facilmente',
                    invite: 'Invita i membri del team a collaborare',
                    insights: 'Statistiche e strumenti di crescita',
                    exposure: 'Esposizione internazionale su LatinMap'
                },
                button: 'Attiva account Pro',
                footer: 'Richiede prima un account Membro'
            }
        },
    },
    dropzone: {
        drop_here: 'Lascia cadere i file qui da caricare',
        files_required: "{Count} richiesto",
        max_filesize: "dimensione massima del file: {max} MB"
    },
    general: {
        select_organization_please: "Si prega di selezionare un'organizzazione",
        no_organization_selected: "Nessuna organizzazione selezionata",
        all: 'tutta',
        styles: 'stili',
        important_information: 'Informazioni importanti',
        starts_at: 'da',
        ends_at: 'A',
        socialmedia_links: 'link',
        share_with_your_friends: 'Condividi con i tuoi amici',
        link_copied: 'Link copiato negli appunti!',
        link_copy_failed: 'Impossibile copiare il link.',
        hosted_by: 'Ospitato da',
        created_by: 'creato da',
        posted_by: 'Pubblicato da',
        created: 'creata',
        archive: 'archivio',
        modified: 'modificato',
        score: 'punto',
        reset: 'reset',
        unknown: 'sconosciuta',
        submit: 'invia',
        suggest: 'suggerire',
        other: 'altra',
        delete: 'eliminare',
        copy_link: 'Copia link',
        back: 'Indietro',
        show: 'spettacolo',
        duplicate: 'duplicato',
        proceed: 'procedere',
        cancel: 'cancellare',
        accept: 'accettare',
        reject: 'rifiutare',
        show_in_new_window: 'Mostra nella nuova finestra',
        checkout: 'guardare',
        external_link_warning: {
            title: 'Link esterno',
            content: 'Stai per lasciare questo sito.',
            question: 'Vuoi continuare verso il seguente URL?',
        },
        add: 'aggiungere',
        date: 'data',
        search: {
            save_new: 'Salva nuova ricerca',
            instructions: 'Salva la ricerca per usarla di nuovo più tardi.',
            name: 'nome',
            none_stored: 'Non hai ancora ricerche salvate.',
            stored: 'Ricerche salvate',
            events: 'eventi',
            organizations: 'organizzazioni',
            paginate: 'per pagina',
            page: 'pagina',
            view: 'visualizzazione',
            filters: 'Filtri',
            delete: 'eliminare',
            views: {
                grid: 'griglia',
                list: 'lista',
                agenda: 'agenda',
                monthlist: 'Elenco dei mesi',
            },
            filter_labels: {
                name: 'nome',
                location: 'posizione',
                dance_styles: 'Stili di danza',
                music_styles: 'Stili musicali',
                event_categories: 'categorie di eventi',
                date_filter: 'data',
                favorites: 'preferite',
                country_codes: 'Codici di paese',
                organization_type: 'Tipi di organizzazione',
            },
        },
        socials: {
            facebook: 'Facebook',
            instagram: 'Instagram',
            site: 'sito web',
            linkedin: 'LinkedIn',
            youtube: 'YouTube',
            tiktok: 'it',
            reddit: 'Reddit',
            pinterest: 'Pinterest',
            twitter: 'X',
            spotify: 'Spotify',
            soundcloud: 'SoundCloud',
            facebook_event: 'Evento Facebook',
            whatsapp: 'WhatsApp',
        },
        description: {
            title: 'descrizione',
            show_more: 'Mostra di più',
            show_less: 'Mostra meno',
        },
        map: 'mappa',
        gmap_block: {
            title: 'mappa',
            location_name: 'Nome della posizione'
        },
        spotify_block: {
            title: 'Spotify',
        },
        soundcloud_block: {
            title: 'SoundCloud',
        },
        paginate: {
            results: 'Risultati',
            filter: 'filtro',
            open_filter: 'filtro aperto',
        },
        edit: 'modificare',
        create: 'creare',
        expand: 'Di più',
        more_info: 'Maggiori informazioni',
        collapse: 'meno',
        unique_impressions: 'impressioni uniche',
        close: 'vicina',
        save_changes: 'Salva le modifiche',
        update_changes: 'Salva le modifiche',
        scrollright: 'Scorri a destra per maggiori dettagli.'
    },
    header: {
        title: 'LatinMap',
        navigation: 'navigazione',
        cta: 'Crea evento',
    },
    date: {
        from: 'da',
        to: 'A',
    },
    report: {
        event: 'Evento di rapporto',
        organization: 'Organizzazione di report',
        name: 'nome',
        location: 'posizione',
        date: 'data',
        success: 'Il tuo rapporto è stato inviato con successo.',
        not_logged_in: 'account richiesto',
        tooltip: 'rapporto',
        status: {
            warning: {
                title: 'Aggiorna lo stato del rapporto',
                body: 'Vuoi davvero modificare lo stato di questo report?'
            }
        },
        archive: {
            warning: {
                title: 'rapporto di archivio',
                body: 'Vuoi davvero archiviare questo report? Questa operazione non può essere annullata.'
            }
        }
    },
    form: {
        save: 'salva',
        save_and_verify: 'Salva e verifica',
        too_many_requests: 'Hai raggiunto il limite del messaggio.' +
            'Attendi qualche minuto prima di inviare un\'altra richiesta',
    },
    form_subject: {
        general_inquiry: "Indagine generale",
        technical_support: "supporto tecnico",
        issue_event_submission: "Problema di presentazione degli eventi",
        issue_account_login: "Account o Emissione di accesso",
        question_billing_payment: "Domanda di fatturazione o pagamento",
        report_issue: "segnalare un problema",
        suggest_feature: "Suggerimento della caratteristica",
        other: "altra"
    },
    api: {
        general: {
            validation_error: 'Errore di convalida',
            permission_denied: 'permesso negato',
            success: 'successo',
        },
        auth: {
            unauthorized: 'Non sei autorizzato ad accedere a questa risorsa.',
            blocked: 'Your account has been blocked, you will not be able to access any features.',
            user_not_found: 'È richiesto un account per utilizzare questa funzionalità, per favore crea prima un account.',
            email_password_unknown: 'L\'indirizzo e -mail o la password forniti non è corretto.',
            email_unverified: 'Il tuo indirizzo email non è verificato.',
            email_already_verified: 'Il tuo indirizzo email è già verificato.',
            phone_already_verified: 'your phonenumber is already verified.',
            phone_already_used: 'Questo numero di telefono è già in uso',
            invalid_verification_link: 'Il collegamento di verifica fornito non è valido.',
            email_verified_success: 'Il tuo indirizzo email è stato verificato.',
            verification_email_sent: 'Un collegamento di verifica è stato inviato al tuo indirizzo email.',
            login_success: 'Hai effettuato l\'accesso con successo.',
            logout_success: 'Ti sei eliminato con successo.',
            registration_success: 'Hai registrato con successo.',
            failed: 'Queste credenziali non corrispondono ai nostri record.',
            password: 'La password fornita non è corretta.',
            throttle: 'Troppi tentativi di accesso.',
            user_updated_success: 'Il tuo account è stato aggiornato con successo.',
            old_password_incorrect: 'La vecchia password fornita non è corretta.',
            password_changed_success: 'La tua password è stata modificata con successo.',
            user_deleted_success: 'Il tuo account è stato eliminato con successo.',
            verification_text_sent: 'Un testo di verifica è stato inviato al tuo numero di telefono.',
            invite_invalid: 'L\'URL di invito usato non è valido.',
            too_many_requests: 'troppe richieste.',
            day_limit_exceeded: 'Oggi hai superato la quantità massima di richieste per questa funzionalità.'
        },
        organization: {
            created_success: 'L\'organizzazione è stata creata con successo.',
            authorized_person: {
                created: 'La persona autorizzata è stata creata con successo.',
                updated: 'La persona autorizzata è stata aggiornata con successo.',
                removed: 'La persona autorizzata è stata rimossa con successo.',
                not_found: 'Non è stato possibile trovare la persona autorizzata.',
                already_exists: 'La persona autorizzata esiste già.',
                role: {
                    singular: 'ruolo',
                    invalid: 'Il ruolo fornito non è valido.',
                    eventPublisher: 'Editore di eventi',
                    eventCreator: 'Creatore di eventi',
                    authorizedPerson: 'persona autorizzata',
                }
            },
        },
        event: {
            created_success: 'L\'evento è stato creato con successo.',
            deleted_success: 'L\'evento è stato eliminato con successo.',
        },
        report: {
            created_success: 'Il rapporto è stato creato con successo.',
            invalid_type: 'Il tipo di report fornito non è valido.',
        },
        user: {
            updated_success: 'L\'utente è stato aggiornato correttamente.',
            search_filter: {
                created: 'creata',
            }
        },
        upload: {
            created_success: 'Il caricamento è stato creato correttamente.',
            deleted_success: 'Il caricamento è stato eliminato con successo.',
        },
        forms: {
            submitted_success: 'Il modulo è stato inviato con successo.',
        },
        passwords: {
            reset: 'La tua password è stata ripristinata.',
            sent: 'Abbiamo inviato via email il link di reimpostazione della password!',
            throttled: 'Si prega di attendere prima di riprovare.',
            token: 'Questo token di reimpostazione della password non è valido.',
            user: 'Non possiamo trovare un utente con quell\'indirizzo e -mail.',
        },
        pagination: {
            previous: '&laquo; precedente',
            next: 'Next &raquo;',
        },
        dance_style: {
            saved_success: 'Lo stile di danza è stato salvato.',
            deleted_success: 'Lo stile di danza è stato eliminato con successo.',
            deleted_error: 'Errore Eliminazione dello stile di danza',
            not_found: 'Non è stato possibile trovare lo stile di danza.',
            parent_not_found: 'Non è stato possibile trovare lo stile di danza dei genitori.',
            suggest_success: 'Suggerimento in stile danza inviato.',
        },
        music_style: {
            saved_success: 'Lo stile musicale è stato salvato.',
            deleted_success: 'Lo stile musicale è stato eliminato con successo.',
            not_found: 'Non è stato possibile trovare lo stile musicale.',
            parent_not_found: 'Non è stato possibile trovare lo stile musicale dei genitori.',
            suggest_success: 'Suggerimento in stile musicale inviato.',
        },
        invite: {
            sent: 'Invito inviato',
            removed: 'Invito rimosso',
            resend_success: 'Invito Resenso'
        },
        transfer_request: {
            already_owner: 'Sei già il proprietario di questa organizzazione.',
            organization_already_owns_event: 'L\'organizzazione possiede già l\'evento.',
        },
        transferlink: {
            removed: 'Il TransferLink è stato rimosso.'
        },
        user_block: {
            create_success: 'User block was successfully created.',
            update_success: 'Il blocco utente è stato aggiornato correttamente.',
            delete_success: 'Il blocco utente è stato eliminato correttamente.'
        },
    },
    favorites: {
        favorite: 'preferita',
        like: 'Piace',
        login_required: 'Devi essere effettuato l\'accesso per aggiungere questo ai tuoi preferiti.',
    },
    likes: {
        login_required: 'Devi essere effettuato l\'accesso per aggiungere questo ai tuoi Mi piace.',
    },
    validations: {
        validations: {
            doesnt_exist: {
                'owner id': 'Impossibile trovare l\'utente per creare questa organizzazione per conto di.'
            }
        },
        on_behalf_of: {
            required: 'è richiesto il campo.',
        },
        required: 'Questo campo è obbligatorio.',
        phone: {
            required: 'Il numero di telefono è richiesto.',
            regex: 'Il numero di telefono non è valido.',
            length: 'Il numero di telefono deve essere lungo almeno 10 cifre.',
        },
        'phone number': {
            required: 'Il numero di telefono è richiesto.',
            regex: 'Il numero di telefono non è valido.',
            'not-unique': 'Questo numero di telefono è già in uso.',
        },
        number: {
            required: 'Il numero è richiesto.',
            invalid: 'Il numero non è valido.'
        },
        email: {
            required: 'L\'indirizzo e -mail è richiesto.',
            invalid: 'L\'indirizzo e -mail non è valido.',
            'not-unique': 'l\'indirizzo email non è univoco.'
        },
        name: {
            required: 'Il nome è richiesto.',
            max_length: 'Il nome è troppo lungo.',
        },
        username: {
            required: 'Il nome utente è richiesto.',
            invalid: 'Il nome utente non è valido.',
        },
        first_name: {
            required: 'È richiesto il nome.',
        },
        last_name: {
            required: 'Il cognome è richiesto.',
        },
        gender: {
            required: 'Il genere è richiesto'
        },
        city: {
            required: 'La città è richiesta.',
        },
        street: {
            required: 'La strada è richiesta.',
        },
        street_number: {
            required: 'Il numero di strada è richiesto.',
        },
        country: {
            required: 'Il paese è richiesto.',
        },
        brand: {
            required: 'Il marchio è richiesto.'
        },
        short_description: {
            required: 'È richiesta la breve descrizione.',
        },
        long_description: {
            required: 'È richiesta la descrizione lunga.',
        },
        description: {
            required: 'La descrizione è richiesta.',
        },
        type: {
            required: 'Il tipo è richiesto.',
        },
        message: {
            required: 'Il messaggio è richiesto.',
        },
        date_of_birth: {
            required: 'La data di nascita è richiesta.',
            regex: 'La data di nascita non è valida.',
            age: 'Devi avere almeno 18 anni.',
            old: 'Devi avere al massimo 120 anni.'
        },
        date: {
            required: 'La data è richiesta.',
            regex: 'La data non è valida.',
        },
        postal_code: {
            required: 'È richiesto il codice postale.',
            length: 'Il codice postale deve essere lungo almeno 4 cifre.',
        },
        entrance: {
            required: 'I prezzi dei biglietti sono obbligatori',
        },
        repeat: {
            required: 'è richiesta la ripetizione.',
        },
        password: {
            required: 'La password è richiesta.',
            regex: 'password valida richiesta.',
            confirmed: 'La conferma della password non corrisponde.',
            mismatch: 'La password non corrisponde.',
        },
        conditions: {
            required: 'È necessario accettare i termini e le condizioni.',
        },
        url: {
            required: 'L\'URL è richiesto.',
            regex: 'L\'URL non è valido.',
        },
        event_category: {
            required: 'Il tipo di evento è richiesto.',
        },
        language_code: {
            required: 'La lingua è richiesta.',
        },
        timezone: {
            required: 'La fuso orario è richiesta.',
        },
        is_public: {
            required: 'La visibilità è richiesta.',
        },
        form_subject: {
            required: 'Il soggetto è richiesto.',
        },
        starts_at: {
            required: 'La data di inizio è richiesta.',
            regex: 'La data di inizio non è valida.',
        },
        start_date: {
            required: 'La data di inizio è richiesta.',
            regex: 'La data di inizio non è valida.',
            after_end_date: "La data di inizio deve essere prima della data di fine.",
        },
        start_time: {
            required: 'È richiesto l\'ora di inizio.',
            regex: 'L\'ora di inizio non è valido.',
        },
        end_date: {
            required: 'La data di fine è richiesta.',
            regex: 'La data di fine non è valida.',
            before_start_date: "La data di fine deve essere dopo la data di inizio.",
        },
        end_time: {
            required: 'È richiesto l\'ora di fine.',
            regex: 'Il tempo di fine non è valido.',
        },
        ends_at: {
            required: 'La data di fine è richiesta.',
            regex: 'La data di fine non è valida.',
            before_start_date: "La data di fine deve essere dopo la data di inizio.",
        },
        registration_opens_at: {
            required: 'È richiesta la data di inizio della registrazione.',
            regex: 'La data di inizio della registrazione non è valida.',
        },
        registration_closes_at: {
            required: 'È richiesta la data di fine della registrazione.',
            regex: 'La data di fine della registrazione non è valida.',
        },
        location_type: {
            required: 'È richiesto il tipo di posizione.',
        },
        location_name: {
            required: 'È richiesto il nome della posizione.',
        },
        dance_styles: {
            required: 'Gli stili di danza sono richiesti.',
        },
        music_styles: {
            required: 'Gli stili musicali sono richiesti.',
        },
        photos: {
            required: 'È richiesta almeno 1 foto.',
        },
        status: {
            required: 'lo stato è richiesto.',
        },
        string: {
            required: '{fieldname} è richiesto.',
            mismatch: '"{input}" non corrisponde "{safeword}".',
        },
        role: {
            required: 'Il ruolo è richiesto.',
        },
        favorite: {
            required: 'Il preferito è richiesto.',
        },
        dance_style: {
            required: 'È richiesto lo stile di danza.',
        },
        facebook: {
            required: 'È richiesto il link Facebook.',
            regex: 'Inserisci un link Facebook valido.',
        },
        facebook_event: {
            required: 'È richiesto il link dell’evento Facebook.',
            regex: 'Inserisci un URL di evento Facebook — deve puntare a facebook.com/events/{id}.',
        },
        instagram: {
            required: 'È richiesto il collegamento Instagram.',
            regex: 'Inserisci un link Instagram valido.',
        },
        website: {
            required: 'È richiesto il collegamento al sito Web.',
            regex: 'Inserisci un link al sito Web valido.',
        },
        twitter: {
            required: 'È richiesto il collegamento X.',
            regex: 'Immettere un link X valido.',
        },
        linkedin: {
            required: 'È richiesto il collegamento LinkedIn.',
            regex: 'Immettere un link LinkedIn valido.',
        },
        youtube: {
            required: 'È richiesto il collegamento YouTube.',
            regex: 'Immettere un link YouTube valido.',
        },
        spotify: {
            required: 'È richiesto il collegamento Spotify.',
            invalid: 'Immettere un link Spotify valido nel formato corretto.',
            regex: 'Immettere un link Spotify valido nel formato corretto.',
        },
        soundcloud: {
            required: 'È richiesto il collegamento SoundCloud.',
            invalid: 'Immettere un link SoundCloud valido nel formato corretto.',
            regex: 'Immettere un link SoundCloud valido nel formato corretto.',
        },
        doesnt_exist: {
            email: 'L\'indirizzo e -mail fornito non esiste.',
            user: 'L\'utente fornito non esiste.',
        },
        djs: {
            required: 'I DJ sono richiesti.',
        },
        artists: {
            required: 'Gli artisti sono richiesti.',
        },
        reason: {
            required: 'Il motivo è richiesto.'
        },
        default: {
            doesnt_exist: {
                email: 'L\'indirizzo e -mail fornito non esiste.',
                user: 'L\'utente fornito non esiste.',
            }
        }
    },
    brand_activity: {
        by_brand: 'utente brand',
        by_admin: 'admin/scraping',
        export: 'Esporta CSV',
    },
    paginatable: {
        headers: {
            last_event_at: 'Ultima attività evento',
            last_event_by: 'Ultimo evento di',
            has_upcoming: 'Prossimi pubblicati',
            id: 'id',
            brand_id: 'identificazione del marchio',
            title: 'titolo',
            slug: 'lumaca',
            group: 'gruppo',
            email: 'indirizzo e-mail',
            phone: 'Numero di telefono',
            name: 'nome',
            first_name: 'nome di battesimo',
            last_name: 'cognome',
            role_name: 'ruolo',
            role: 'ruolo',
            report: 'rapporto',
            created_at_formatted: 'creato a',
            status: 'stato',
            actions: 'azioni',
            type: 'tipa',
            to_user_email: 'A indirizzo e-mail',
            from_user_email: 'Da indirizzo e-mail',
            reason: 'motivo',
            organization_name: 'Nome dell\'organizzazione',
            organization_created: 'organizzazione creata',
            organization_updated: 'Organizzazione Ultimo aggiornamento',
            confirmed_at: 'confermato a',
            organization_role: 'ruolo',
            sub_dance_styles: 'Stili di danza secondaria',
            sub_music_styles: 'stili di musica sub',
            city: 'città',
            created_at: 'creata',
            updated_at: 'modificato',
            is_favorite: 'preferita',
            starts_at: 'inizia da',
            tickets_sold: 'Biglietti venduti',
            price: 'prezzo',
            start_date: 'Data di inizio',
            is_public: 'pubblica',
            available_tickets: 'Biglietti disponibili',
            user_id: 'ID utente',
            transferable_type: 'tipa',
            content_name: 'titolo',
            paynl_transaction_id: 'transazione paynl',
            date: 'Data di acquisto',
            amount: 'importo totale',
            tax_amount: 'tassare',
            currency: 'valuta',
            description: 'descrizione',
            valid_from: 'inizio',
            valid_until: 'scadenza',
            items: 'elementi',
            total: 'totale',
            featured: 'in primo piano',
            created_by: 'utente',
            location_type: 'Tipo di posizione',
            category_id: 'categoria',
            organization_category_id: 'categoria',
            country_code: 'Codice del paese',
            location: 'posizione',
            info: 'Informazioni sull\'utente',
            owner: 'rappresentante',
            adres: 'indirizzo',
            export_created: 'esportazione creata',
            image_path: "Percorso immagine",
            image_alt: "Testo alternativo immagine",
            image_title: "Titolo immagine",
            image: "Immagine",
            visibility: "Visibilità",
            order_by: "Ordina per",
            public_status: "Stato pubblico",
            country: 'Paese',
            activity: 'Attività',
        },
        search: 'ricerca',
        no_records: 'Nessun risultato trovato',
    },
    pages: {
        related: 'pagine correlate',
        contact: {
            title: 'contattare Latinmap',
            body: 'Per domande relative agli eventi, contattare l\'organizzazione che ha pubblicato l\'evento.'
        },
        'how-it-works': {
            title: 'Come funziona',
            body: '<p> Vendita di biglietti online tramite latinmap.com </p><p> Offriamo alle organizzazioni la possibilità di vendite di biglietti online.'
        },
        'goods-and-services': {
            title: 'beni e servizi',
            body: '<p> latinmap.com: scopri e sperimenta il mondo della danza latina </p><p> Benvenuto su Latinmap.com, la destinazione in cui ottieni accesso senza sforzo agli eventi e alle esperienze più eccitanti nel mondo della danza latina.'
        },
        'terms-and-conditions': {
            title: 'Termini e Condizioni',
            body: '<p>20230529 Termini e condizioni di vendita dei biglietti</p><p>1. Definizioni</p><p>I termini qui definiti con la lettera maiuscola iniziale hanno il seguente significato in questi Termini e condizioni:<br/>a. Termini e condizioni: queste condizioni generali di vendita dei biglietti della Fondazione LatinMap.com<br/>b. Evento: l\'evento organizzato, come un evento di natura musicale, culturale, sportiva e/o ricreativa, per il quale la Fondazione LatinMap.com vende i Biglietti<br/>c. Organizzatore dell\'evento: la persona fisica o giuridica che produce o organizza un Evento e ne è responsabile<br/>d. Cliente: la persona fisica o giuridica che stipula un accordo con la Fondazione LatinMap.com in relazione a un Evento, o a cui la Fondazione LatinMap.com fa un\'offerta per farlo<br/>e. Accordo: l\'accordo tra la Fondazione LatinMap.com e il Cliente per l\'acquisizione di Biglietti per Eventi<br/>f. Biglietto: il documento che funge da biglietto di ingresso per un Evento, inclusi i Biglietti elettronici</p><p>2. Applicabilità</p><p>a. Questi Termini e Condizioni si applicano a tutte le offerte, gli ordini con, i rapporti legali e gli accordi in cui la Fondazione LatinMap.com fornisce prodotti o servizi di qualsiasi tipo al Cliente, anche se questi prodotti o servizi non sono (ulteriormente) descritti in questi Termini e Condizioni.<br/>b. La Fondazione LatinMap.com rifiuta espressamente l\'applicabilità di qualsiasi altra condizione del Cliente.<br/>c. Le parti possono concordare solo deviazioni dai Termini e Condizioni per iscritto. La Fondazione LatinMap.com ha il diritto di modificare i Termini e Condizioni e di dichiarare i termini e le condizioni generali modificati applicabili agli Accordi. I termini e le condizioni generali modificati possono essere consultati sul sito web della Fondazione LatinMap.com. d. L\'Accordo è soggetto ai termini e alle condizioni generali dell\'Organizzatore dell\'Evento. Se non già in possesso del Cliente, l\'Organizzatore dell\'Evento invierà i termini e le condizioni generali dell\'Organizzatore dell\'Evento al Cliente su richiesta.</p><p>3. Formazione dell\'Accordo</p><p>a. Salvo diverso accordo scritto, tutte le offerte, comprese le pubblicità e i listini prezzi come menzionati sul sito web della Fondazione LatinMap.com, sono senza impegno. b. Nell\'offrire e vendere Biglietti, la Fondazione LatinMap.com agisce come mediatore nella formazione del Contratto tra Acquirente e Organizzatore dell\'Evento. La Fondazione LatinMap.com non è parte del Contratto che si conclude con l\'acquisto di un Biglietto. Il Contratto si conclude dopo che il Cliente ha acquistato uno o più Biglietti tramite la Fondazione LatinMap.com. La Fondazione LatinMap.com fornisce i Biglietti per conto dell\'Organizzatore dell\'Evento.<br/>c. Prima di confermare la prenotazione, il Cliente deve sempre controllare se sono stati prenotati i Biglietti corretti. Quando effettua la prenotazione, il Cliente deve sempre utilizzare un indirizzo (e-mail) corretto. Se il Cliente sceglie di ricevere i Biglietti elettronicamente, il rischio di smarrimento, furto o uso improprio del Biglietto è a carico del Cliente dal momento in cui i Biglietti gli sono pervenuti. In caso di dubbi sull\'accuratezza dei dati inseriti dal Cliente al momento dell\'ordine, la Fondazione LatinMap.com può contattare il Cliente utilizzando i dati inseriti dal Cliente. Se la Fondazione LatinMap.com non riesce a raggiungere il Cliente e quindi non può verificare i dati, la Fondazione LatinMap.com può procedere ad annullare la prenotazione e vendere i Biglietti a un altro Cliente. Se la Fondazione LatinMap.com dubita dell\'accuratezza o della validità dei dati inseriti dal Cliente al momento dell\'ordine o del metodo di pagamento utilizzato dal Cliente, ha il diritto di annullare la prenotazione del Cliente e vendere i Biglietti a un altro Cliente. La Fondazione LatinMap.com si impegnerà a informare il Cliente in tal caso. Ogni Contratto viene stipulato sotto la condizione sospensiva di sufficiente disponibilità dei rispettivi prodotti o servizi.<br/>d. La Fondazione LatinMap.com e/o l\'Organizzatore dell\'Evento si riservano il diritto di stabilire un numero massimo di Biglietti che possono essere prenotati/acquistati. Se questo massimo viene superato dal Cliente, la Fondazione LatinMap.com e/o l\'Organizzatore dell\'Evento hanno il diritto di annullare la prenotazione dei Biglietti oltre il numero massimo o di invalidare i Biglietti interessati.<br/>e. I Biglietti non possono essere restituiti. La disposizione dell\'articolo 6:230p sub e BW si applica ai biglietti.</p><p>4. Prezzi e pagamento</p><p>a. La Fondazione LatinMap.com vende biglietti per conto degli organizzatori di eventi che determinano il prezzo e il numero di posti disponibili. Le informazioni relative a prezzo e disponibilità sono fornite senza impegno e soggette a modifica.<br/>b. Il cliente paga i prodotti o servizi ordinati tramite il sito Web, il prezzo indicato nel Contratto. Il pagamento viene effettuato secondo le modalità indicate sul sito Web della Fondazione LatinMap.com. Ulteriori condizioni (pagamento/ordine) possono essere applicate all\'ordine.</p><p>c. Tutti i prezzi della Fondazione LatinMap.com come indicato sul sito Web sono in euro IVA inclusa, salvo diversamente specificato.<br/>d. La Fondazione LatinMap.com addebita commissioni di servizio per ogni ordine. Inoltre, la Fondazione LatinMap.com addebita commissioni amministrative calcolate in base all\'importo totale della transazione.</p><p>e. Se il cliente non paga gli importi dovuti in tempo, il cliente è, senza la necessità di alcuna richiesta o avviso di inadempimento, tenuto a pagare gli interessi legali sull\'importo in sospeso. Se il Cliente rimane negligente nel risolvere il reclamo dopo una richiesta o una notifica di inadempimento, la Fondazione LatinMap.com può consegnare il reclamo, nel qual caso il Cliente è anche tenuto a rimborsare tutti i costi giudiziari ed extragiudiziali, inclusi i costi calcolati da esperti esterni oltre ai costi stabiliti per legge.</p><p>5. Tempi di consegna</p><p>a. I biglietti vengono inviati all\'indirizzo (e-mail) fornito dal Cliente al momento dell\'ordine. La Fondazione LatinMap.com continuerà a considerare corretto l\'indirizzo (e-mail) fornito dal Cliente fino a quando il Cliente non notificherà alla Fondazione LatinMap.com un nuovo indirizzo (e-mail). b. I tempi di consegna indicati dalla Fondazione LatinMap.com non saranno mai considerati una scadenza rigorosa, salvo diverso accordo espresso. In caso di consegna non tempestiva, la Fondazione LatinMap.com deve ricevere una notifica scritta di inadempimento.</p><p>c. Il superamento di qualsiasi tempo di consegna non dà diritto al Cliente a un risarcimento né al diritto di annullare l\'ordine o di rescindere il Contratto, a meno che il tempo di consegna non sia stato superato a tal punto da rendere irragionevole aspettarsi che il Cliente mantenga il Contratto.</p><p>d. Ad eccezione dell\'opzione di ordinare Biglietti elettronici, le vendite di Biglietti tramite il sito Web e il call center vengono interrotte 8 giorni prima della data dell\'Evento per dare alla Fondazione LatinMap.com l\'opportunità di inviare comunque i Biglietti per posta.</p><p> 6. Eventi annullati e riprogrammati </p><p> a. È responsabilità del Cliente verificare se un Evento è stato annullato o riprogrammato e quale sarà il nuovo orario o luogo. Sebbene Stichting LatinMap.com tenterà di notificare al Cliente l\'annullamento dopo aver ricevuto le informazioni necessarie dall\'Organizzatore dell\'Evento, Stichting LatinMap.com non può garantire che il Cliente verrà informato dell\'annullamento prima della data dell\'Evento. </p><p> b. Stichting LatinMap.com non è responsabile per eventuali costi sostenuti.<br/>c. I biglietti per gli Eventi riprogrammati rimangono generalmente validi per l\'Evento sostitutivo. Per maggiori informazioni in merito, il Cliente può contattare Stichting LatinMap.com tramite il nostro indirizzo e-mail: mail(at)LatinMap.com. Se un Evento viene spostato in un\'altra sede o data, l\'Organizzatore dell\'Evento può imporre condizioni sul rimborso del prezzo del biglietto.<br/>d. Se un Evento viene annullato o riprogrammato, il Cliente può restituire i Biglietti per questo Evento in conformità con l\'accordo determinato dall\'Organizzatore dell\'Evento. Per le condizioni pertinenti, ti rimandiamo ai Termini e Condizioni Generali dell\'organizzatore dell\'evento. Se l\'Organizzatore dell\'Evento richiede a Stichting LatinMap.com di rimborsare il prezzo del biglietto al Cliente, Stichting LatinMap.com lo farà dopo aver ricevuto i fondi pertinenti dall\'Organizzatore dell\'Evento. Le spese di servizio e di amministrazione non vengono rimborsate. </p><p> 7. Biglietti </p><p> a. I Biglietti distribuiti da Stichting LatinMap.com rimangono di proprietà dell\'Organizzatore dell\'Evento. Al Cliente non è consentito rivendere un Biglietto se ciò viola la legge. Inoltre, un Organizzatore dell\'Evento può vietare la rivendita o l\'uso commerciale di un Biglietto. Il Cliente deve verificarlo nei termini e condizioni generali dell\'organizzatore, a cui si fa riferimento sul Biglietto (e durante il processo di ordinazione). In caso di (tentativo) di rivendita o uso commerciale in violazione della legge o delle condizioni dell\'Organizzatore dell\'Evento, l\'Organizzatore dell\'Evento ha il diritto di invalidare il Biglietto in questione e/o imporre una multa al Cliente. Ai titolari di pass di accesso non validi verrà negato l\'accesso all\'Evento, senza alcun diritto a indennizzo.<br/>b. Al momento della ricezione, il Cliente deve controllare i Biglietti, poiché gli errori non possono sempre essere corretti. Dopo l\'acquisto, i Biglietti non possono essere cambiati o rimborsati.<br/>c. Se il biglietto del cliente è così danneggiato che non è più possibile verificarne l\'autenticità, il cliente può contattare il servizio clienti online.<br/>d. Richieste speciali, come la prenotazione di posti per sedie a rotelle, devono essere comunicate in modo tempestivo ed esplicito. Stichting LatinMap.com non può garantire che le richieste speciali possano essere soddisfatte. Per maggiori informazioni in merito, il cliente può contattare Stichting LatinMap.com tramite il nostro indirizzo e-mail: mail(at)LatinMap.com </p><p> 8. Diritti di proprietà intellettuale e industriale </p><p> a. I diritti di proprietà intellettuale e industriale che gravano sul biglietto di Stichting LatinMap.com appartengono a Stichting LatinMap.com o al suo licenziatario. Il cliente si asterrà da qualsiasi azione che possa violare i diritti o altri interessi di Stichting LatinMap.com o del suo licenziatario.<br/>b. Al Cliente non è consentito rimuovere o modificare alcuna indicazione di copyright, marchi, nomi commerciali o altri diritti di proprietà intellettuale o industriale dal Biglietto, né apportare modifiche alla forma o a qualsiasi altra caratteristica del Biglietto.<br/>c. Al Cliente è vietato contraffare, duplicare o riprodurre il Biglietto in alcun modo.<br/>d. Il Contratto non si estende al trasferimento di alcun diritto di proprietà intellettuale da Stichting LatinMap.com al Cliente. </p><p> 9. Privacy </p><p> a. I dati forniti dal Cliente al momento dell\'acquisto dei biglietti saranno utilizzati esclusivamente da Stichting LatinMap.com per migliorare i propri servizi.<br/>b. I dati forniti dal Cliente al momento dell\'acquisto dei biglietti non saranno mai resi disponibili a terzi. </p><p> c. I dati forniti dal Cliente al momento dell\'acquisto dei biglietti saranno disponibili all\'Organizzazione venditrice. È possibile che l\'organizzazione utilizzi i dati per inviare mailing.<br/>d. Ci aspettiamo che i nostri clienti gestiscano queste informazioni con attenzione. In caso contrario, vorremmo saperlo e informeremo il cliente interessato e, se lo riterremo necessario, escluderemo il cliente dalla vendita dei biglietti online. </p><p> e. Nota: non accettiamo alcuna responsabilità per l\'informativa sulla privacy dei nostri clienti. </p><p> 10. Responsabilità </p><p> a. Stichting LatinMap.com non può essere considerato l\'organizzatore (Organizzatore dell\'Evento) dell\'Evento e non è responsabile né garantisce la qualità (artistica) e il contenuto dell\'Evento e lo svolgimento degli eventi all\'interno o intorno all\'Evento, e non accetta alcuna responsabilità su questa base. </p><p> b. Fatta eccezione per le altre disposizioni sulla responsabilità in questi Termini e Condizioni Generali, la responsabilità totale di Stichting LatinMap.com per inadempimento attribuibile o per atto illecito è limitata al risarcimento per danni diretti fino a un importo non superiore a quello che è stato o può essere addebitato al Cliente per i Biglietti, a meno che il danno non sia il risultato di dolo e/o grave negligenza di </p><p> Stichting LatinMap.com o dei suoi subordinati.<br/> c. La responsabilità di Stichting LatinMap.com per inadempimento imputabile di un contratto sorge in tutti i casi solo se il Cliente dichiara tempestivamente e correttamente Stichting LatinMap.com inadempiente per iscritto, fissando un termine ragionevole per la riparazione dell\'inadempimento, e Stichting LatinMap.com continua anche dopo tale termine a non adempiere in modo imputabile ai propri obblighi. La comunicazione di inadempimento deve contenere una descrizione dell\'inadempimento il più possibile completa e dettagliata, in modo che Stichting LatinMap.com possa rispondere adeguatamente.<br/> d. Il Cliente indennizza Stichting LatinMap.com da tutte le pretese di terzi relative all\'inadempimento o all\'insufficiente adempimento da parte del Cliente di qualsiasi obbligo nei confronti di Stichting LatinMap.com, derivante o meno dai Termini e Condizioni Generali.<br/> e. Una condizione per l\'esistenza di qualsiasi diritto al risarcimento è sempre che il Cliente segnali il danno a Stichting LatinMap.com per iscritto il prima possibile dopo il suo verificarsi. f. Stichting LatinMap.com non può mai essere ritenuta responsabile per alcun tipo di danno o smarrimento del Biglietto. In caso di smarrimento o furto, il Cliente non può richiedere un Biglietto sostitutivo o il rimborso di alcun importo. Stichting LatinMap.com non è inoltre responsabile per ritardi o mancata consegna o consegna errata dei Biglietti, se il ritardo, la mancata consegna o la consegna errata non possono essere attribuiti a Stichting LatinMap.com.<br/> g. Stichting LatinMap.com non accetta alcuna responsabilità per i Biglietti ottenuti da terzi dal Cliente. Stichting LatinMap.com non può nemmeno garantirne l\'autenticità.<br/> h. Stichting LatinMap.com non può in alcun modo essere ritenuta responsabile per eventuali danni subiti dal titolare di questo biglietto di ingresso a causa di azioni od omissioni di terzi. </p><p> 11. Forza maggiore </p><p> a. Per forza maggiore si intende qualsiasi inadempimento che non può essere attribuito a Stichting LatinMap.com, perché non è dovuto a sua colpa e né ai sensi della legge, dell\'atto giuridico né secondo gli standard generalmente accettati è per suo conto.<br/> b. Fatto salvo ogni altro suo diritto, Stichting LatinMap.com ha il diritto di sospendere l\'esecuzione dell\'ordine del Cliente in caso di forza maggiore, dandone comunicazione scritta al Cliente e senza che Stichting LatinMap.com sia tenuta ad alcun risarcimento, a meno che ciò non sia inaccettabile secondo gli standard di ragionevolezza ed equità nelle circostanze date. </p><p> 12. Legge applicabile e foro competente </p><p> a. Tutti gli accordi con Stichting LatinMap.com sono regolati dalla legge olandese. </p><p> 13. Varie </p><p> a. I clienti che arrivano in ritardo all\'Evento saranno ammessi, per quanto possibile, durante i momenti opportuni dell\'Evento. Tuttavia, l\'ingresso non può essere garantito.<br/> b. Laddove questi Termini e Condizioni Generali obblighino Stichting LatinMap.com a effettuare una comunicazione scritta, Stichting LatinMap.com ha il diritto di effettuare tale comunicazione elettronicamente, ad esempio, ma non limitatamente a, un messaggio di posta elettronica o un fax.<br/> c. Errori evidenti ed errori tipografici sul sito web di Stichting LatinMap.com o in preventivi, conferme d\'ordine, biglietti e/o altri documenti, non vincolano Stichting LatinMap.com. d. In caso di disaccordo tra Stichting LatinMap.com e il Cliente in merito alla traduzione e/o all\'interpretazione delle Condizioni Generali, sarà determinante la versione olandese delle stesse.<br/> e. Se una o più disposizioni delle presenti Condizioni Generali o di qualsiasi altro accordo con Stichting LatinMap.com dovesse entrare in conflitto con qualsiasi requisito legale applicabile, la disposizione in questione sarà nulla e sostituita da una nuova disposizione comparabile legalmente ammissibile che dovrà essere determinata da Stichting LatinMap.com.</p>'
        },
        'privacy-policy': {
            title: 'politica sulla riservatezza',
            body: '<p> Informativa sulla privacy per latinmap.com: scopri e sperimenta il mondo della danza latina <br> Ultimo aggiornamento: 23-05-2023 <br> Grazie per aver visitato latinmap.com, la destinazione per scoprire e sperimentare il mondo della danza latina.'
        },
        about: {
            'about-latin-scene': {
                title: "sulla scena latina",
                body: "La scena della danza latina è una comunità vibrante e diversificata che celebra il ricco patrimonio culturale dell\'America Latina attraverso musica, danza e arte."
            },
            salsa: {
                title: "salsa",
                body: "Salsa è una forma popolare di danza sociale che ha avuto origine nei Caraibi."
            },
            bachata: {
                title: "Bachata",
                body: "Bachata è un genere di musica latinoamericana che ha avuto origine nella Repubblica Dominicana nella prima metà del 20 ° secolo con elementi musicali europei, indigeni e africani."
            },
            zouk: {
                title: "Zouk",
                body: "Zouk è uno stile di battito di carnevale di salto rapido di musica ritmica proveniente dalle Isole Caraibi di Guadeloupe e Martinica, reso popolare dalle Antille francesi Kassav \'negli anni \'80."
            },
            kizomba: {
                title: "Kizomba",
                body: "Kizomba è un genere musicale e uno stile di danza proveniente dall\'Angola alla fine degli anni \'70 e all\'inizio degli anni \'80."
            },
            cuban: {
                title: "cubana",
                body: "La musica e la danza cubana sono profondamente radicate nel diverso patrimonio culturale dell\'isola, fondendo influenze africane, spagnole e indigene."
            }
        },
        'help-center-faq': {
            title: 'Centro assistenza',
        },
        'cookie-policy': {
            title: 'Politica sui cookie',
        },
        'create-an-event': {
            title: 'Come creare un evento',
        },
        'create-an-brand-or-an-organization': {
            title: 'Come creare un marchio',
        },
        'become-an-ambassador': {
            title: 'diventare un ambasciatore',
        },
        'promote-your-event': {
            title: 'Come promuovere il tuo evento',
        },
        'professional-account-verification': {
            title: 'Verifica del conto professionale'
        },
        'about-us': {
            title: 'Chi siamo',
        },
    },
    email: {
        'not-unique': 'L\'e -mail è già stata presa.',
    },
    leads: {
        title: 'Invia il lead',
        description_p1: 'Sei un utente di LatinMap e hai trovato una scuola di danza, un\'organizzazione o un evento che non è ancora elencato? Invialo qui — il tuo contributo ci aiuta a mantenere la piattaforma completa, accurata e preziosa per i ballerini di tutto il mondo.',
        description_p2: 'Sei un organizzatore e vuoi essere elencato su LatinMap? Crea un Account Pro e aggiungi gratuitamente le tue attività alla piattaforma!',
        description_p3: 'Grazie per aiutarci a far crescere LatinMap, la piattaforma che connette la comunità globale della danza.',
        plural: 'conduce',
        type: {
            event: 'evento',
            organization: 'organizzazione',
            label: 'tipa',
        },
        name: 'nome',
        address: 'indirizzo',
        country: 'Paese',
        city: 'città',
        street: 'strada',
        street_number: 'numero di strada',
        dance_styles: 'Stili di danza',
        music_styles: 'Stili musicali',
        photos: 'foto',
        category: 'Tipo di evento',
        location_name: 'Nome del luogo',
        location_type: {
            singular: 'Tipo di posizione',
            online: 'virtuale',
            offline: 'di persona',
        },
        timezone: 'fuso orario',
        date: 'data',
        not_posted_by_ambassador: 'Verificato dall\'organizzatore',
        undercondition: 'in condizioni',
        warning: 'cambiamento importante',
        cancelled: 'annullata',
        posted_by_ambassador: 'Postato da Latinmap Ambassador',
        upcoming: 'eventi imminenti',
        status_options: {
            active: 'attiva',
            canceled: 'annullata',
            pending: 'non ancora confermato',
            changed: 'cambiamento importante',
            submitted: 'Presentato',
            under_review: 'in revisione',
            implemented: 'implementata',
            declined: 'rifiutato',
        },
        submit: 'invia',
        success: 'Il lead è stato presentato.',
        filter_type: 'Filtro per tipo',
        view: 'Guida',
        confirm_delete: 'Elimina il lead',
        delete_confirmation: 'Sei sicuro di voler eliminare questo lead?',
        deleted_successfully: 'Il comando è stato eliminato con successo.',
        error_loading: 'Lead di caricamento degli errori',
        status_updated: 'Lo stato del lead è stato aggiornato.',
        error_status: 'Errore aggiornamento dello stato del lead',
    },
    search: {
        allOragnisations: 'Visualizza tutte le scuole di danza',
        allEvents: 'Visualizza tutti gli eventi',
        searchresult: 'Risultati di ricerca',
        type: 'Tipa',
        title: 'titolo',
        city: 'città',
        country: 'Paese',
        address: 'indirizzo',
        startdate: 'Data di inizio',
        favorite: 'preferita'
    },
    components: {
        picture_input: {
            drag: "Carica Avatar",
            remove: 'Elimina Avatar',
            change_avatar: 'Cambia Avatar'
        },
        pictureInput: {
            drag: "Clicca qui per caricare l'immagine",
            change: "Cambia",
            remove: "Rimuovi",
            upload: "Carica",
            tap: "Tocca per caricare",
            select: "Seleziona un file",
            selected: "Selezionato",
            fileSize: "Dimensione file",
            fileType: "Tipo di file",
            aspect: "Proporzioni"
        },
    },
    passion: {
        title: "Senti il Ritmo, Unisciti al Movimento",
        subtitle: "Scopri il vibrante mondo della danza latina. Connettiti con ballerini, trova eventi vicino a te e lascia che la musica muova la tua anima.",
    },
    payment: {
        received: "pagamento ricevuto",
        thank_you: "Grazie per il tuo acquisto!",
        download_ticket: "Scarica i biglietti",
        download_button: "Scarica i biglietti",
        email_check: "Controlla la tua casella di posta, inclusa la cartella SPAM, per un\'e -mail dal nostro sistema di biglietteria.",
        failed: "Pagamento in sospeso",
        failed_message: "Sfortunatamente, abbiamo riscontrato un problema che elabora il pagamento.",
        download_invoice: "Scarica fattura",
        download_invoice_button: "Scarica fattura",
        invoice_check: "Controlla la tua casella di posta per la tua fattura.",
        thank_you_for_purchase: "Grazie per aver acquistato l\'evento in primo piano!",
    },
    financial_center: {
        financial_dashboard: 'La mia dashboard finanziaria',
        title: "Centro finanziario",
        description: "Gestisci transazioni, pagamenti, promozioni e funzionalità premium.",
        overview: "Panoramica",
        transactions: "transazioni",
        payoutsettings: "Impostazioni di pagamento",
        featured_events: "Eventi in primo piano",
        ticketsales: "Vendita di biglietti",
        premium: "account premium",
    },
    inputfield: {
        select_here: 'Seleziona qui',
    },
    tooltip: {
        edit: 'modificare',
        delete: 'eliminare',
        view: 'visualizzazione',
        hide: 'nascondere',
        under_construction: 'in costruzione',
    },
    // LA-157: where someone stops the automated emails LatinMap sends.
    email_preferences: {
        error: "Qualcosa è andato storto. Riprova tra poco.",
        confirm: {
            title: "Non ricevere più queste e-mail?",
            body: "Al momento ricevi queste e-mail automatiche su {email}.",
            note: "I messaggi sul tuo account, come il reset della password, continueranno ad arrivare.",
            button: "Interrompi queste e-mail",
        },
        done: {
            title: "Non riceverai più nulla",
            body: "Non invieremo più e-mail automatiche a {email}.",
            undo: "Riceverle di nuovo",
        },
        unknown: {
            title: "Questo link non funziona più",
            body: "Il link non è valido. Usa quello di un'e-mail più recente.",
        },
    },
    // LA-194: the public page an organiser reaches through a submission link.
    submit_event: {
        eyebrow: 'Invia un evento',
        title: 'Invia il tuo evento a LatinMap',
        title_brand: 'Invia un evento per {brand}',
        lede: 'Compila quello che sai. Lo prepariamo e lo pubblichiamo dopo un breve controllo.',
        loading: 'Un attimo…',
        notes: {
            no_account: 'Nessun account necessario — basta questo link',
            checked: 'Controlliamo ogni evento prima della pubblicazione',
            reply: 'Se qualcosa non è chiaro, ti scriviamo',
        },
        sections: {
            event: 'L\'evento',
            where: 'Dove',
            details: 'Dettagli',
            you: 'Su di te',
        },
        fields: {
            name: 'Nome dell\'evento',
            organizer_name: "Nome dell'organizzatore / brand",
            organizer_url: "Sito web o social dell'organizzatore",
            start_date: 'Data',
            start_time: 'Ora di inizio',
            end_date: 'Data di fine',
            end_time: 'Ora di fine',
            dance_styles: 'Stili di ballo',
            event_category: "Tipo di evento",
            event_category_placeholder: "Scegli un tipo di evento",
            location_name: 'Locale',
            city: 'Città',
            country: 'Paese',
            country_placeholder: 'Scegli un paese',
            short_description: 'Descrizione breve',
            description: 'Descrizione completa',
            link: 'Link a informazioni o biglietti',
            photo: "Foto",
            photo_remove: "Rimuovi foto",
            your_name: 'Il tuo nome',
            your_email: 'Il tuo indirizzo e-mail',
        },
        hints: {
            organizer: 'Chi organizza questo evento? Un link al sito o a Instagram ci aiuta a trovare il brand giusto.',
            end_date: "Per un evento di un giorno è la stessa data dell'inizio.",
            contact: 'Lo usiamo solo per contattarti riguardo a questo evento.',
            photo: "Facoltativo. JPG, PNG o WebP, fino a 8 MB.",
        },
        errors: {
            name: 'Inserisci il nome dell\'evento.',
            start_date: 'Inserisci la data.',
            end_date: "Inserisci la data di fine.",
            event_category: "Scegli un tipo di evento.",
            too_many: "Hai provato troppe volte. Aspetta un attimo e riprova.",
            city: 'Inserisci la città.',
            country: 'Scegli un paese.',
            organizer_name: 'Indica chi organizza questo evento.',
            email: 'Inserisci un indirizzo e-mail valido.',
            failed: 'Invio non riuscito. Riprova tra poco.',
            photo_type: "Scegli un JPG, PNG o WebP.",
            photo_size: "Questa foto è troppo grande. Massimo 8 MB.",
        },
        submit: 'Invia evento',
        done: {
            title: 'Grazie, abbiamo il tuo evento',
            body: 'Qualcuno di LatinMap lo guarderà. Riceverai una conferma via e-mail.',
            again: 'Invia un altro evento',
        },
        invalid: {
            title: 'Questo link non funziona più',
            body: 'Il link è scaduto o è stato ritirato. Chiedine uno nuovo.',
        },
    },
    // LA-180: the screen Brevo returns to after a subscription is
    // confirmed. Top-level rather than under footer, because the same
    // confirmation ends both the footer form and the signup opt-in.
    newsletter: {
        // LA-176: the fixed sign-up landing page behind every QR code,
        // social bio and e-mail signature.
        stay_updated: {
            title: 'Resta vicino alla scena',
            lede: 'Ricevi gli eventi di danza latina per cui vale la pena tenere libera la serata: feste, festival, workshop e lezioni di prova, più le novità e i concorsi di LatinMap.',
            benefits: {
                agenda: 'L\'agenda, prima di tutti gli altri',
                festivals: 'Festival e congressi per cui vale la pena viaggiare',
                features: 'Le nuove funzioni di LatinMap appena escono',
                community: 'Concorsi e notizie dalla community',
            },
            form_title: 'Iscriviti',
            email_label: 'Il tuo indirizzo e-mail',
            submit: 'Iscrivimi alla lista',
            terms: 'Una e-mail alla volta, e il tuo indirizzo non va mai a nessun altro. Puoi disiscriverti con un clic, da ogni messaggio.',
            done: {
                title: 'Controlla la tua casella',
                body: 'Ti abbiamo inviato una e-mail. Clicca sul link per confermare e sarai nella lista.',
                again: 'Iscrivi un altro indirizzo',
            },
        },
        confirmed: {
            title: 'Iscrizione confermata',
            success: 'La tua iscrizione è confermata. Benvenuto!',
            body: 'Da ora riceverai la newsletter di LatinMap: i migliori eventi di danza latina direttamente nella tua casella di posta. Puoi disiscriverti con un clic da ogni newsletter.',
            discover_events: 'Scopri gli eventi',
            back_home: 'Torna alla home',
        },
    },
    footer: {
        section_1: {
            title: 'Scopri LatinMap',
            about: 'Chi siamo',
            how_it_works: 'Come funziona',
            search: 'Cerca',
            contact: 'Contattaci',
        },
        section_2: {
            title: 'Supporto e comunità',
            help: 'Centro assistenza',
            privacy_policy: 'Politica sulla riservatezza',
            terms_and_conditions: 'Termini e condizioni generali di contratto',
            cookie_policy: 'Informativa sui cookie',
        },
        section_3: {
            title: 'per professionisti',
            create_event: 'Come creare un evento',
            create_organization: 'Come creare un marchio',
            become_ambassador: 'diventare un ambasciatore',
            promote_event: 'Come promuovere il tuo evento',
            professional_account_verification: 'Verifica del conto professionale'
        },
        section_4: {
            title: 'Categorie di danza ed eventi',
            all_events: 'Tutti gli eventi',
        },
        follow_our_socials: 'Segui i nostri social media',
    }
};
